import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { api } from "../api";
import { showInfo as toastInfo, showError as toastError } from "../utils/toast";
import ModalAdicionarPlanos from "../components/modalPlanosDisponiveis.jsx";
import ConfirmDialog from "../components/ui/confirmModal.jsx";
import axios from "axios";

import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../components/ui/accordion.jsx";
import {
  Tabs,
  TabsContent,
} from "../components/ui/tab.jsx";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { SwitchButton } from "../components/ui/switch.jsx";
import MainLayout from "../components/mainLayout";
import SelectCliente from "../components/ui/selectCliente.jsx";
import { FiDownload, FiEdit, FiTrash } from "react-icons/fi";
import "../sass/pages/cadastroScreen.scss";
import "../sass/pages/cadastroFuncScreen.scss"; // reutiliza o padrão visual tezte
import ChamadosChart from "../components/ui/chamadosPorClienteChart.jsx";
import ContratoClientePanel from "../components/ContratoClientePanel.jsx";

import { Eye, EyeOff } from "lucide-react";

const DEFAULT_RESUMO = { Quitado: 0, Pendente: 0, Cancelado: 0, total: 0 };

const DEFAULT_FILTRO_BOLETO = {
  nrLicenca: "",
  de: "",
  ate: "",
  search: "",
  minValor: "",
  maxValor: "",
  situacoes: { Quitado: true, Pendente: true, Cancelado: true },
  page: 1,
  limit: 20,
};

const TIPOS_PDV = ["Servidor Web", "Sistema Local", "SPW"];

const CODIGO_EMITENTE_NFSE = "19118";
const ID_EMPRESA_EMITENTE_NFSE = 1;

const getApiErrorMessage = (error, fallback) => {
  return (
    error?.response?.data?.detalhe ||
    error?.response?.data?.message ||
    error?.response?.data?.mensagem ||
    error?.response?.data?.error ||
    error?.message ||
    fallback
  );
};

const toBoolFlag = (value) => {
  if (value === true || value === 1) return true;

  const text = String(value ?? "").trim().toLowerCase();

  return ["1", "true", "s", "sim", "yes"].includes(text);
};


const normalizarSomenteNumeros = (valor) =>
  String(valor ?? "")
    .trim()
    .replace(/\D/g, "");

const normalizarDocumentoFiscal = (valor) =>
  String(valor ?? "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");

const valorCnpjAlfa = (char) => char.charCodeAt(0) - 48;

const calcularDigitoCnpjAlfa = (base, pesos) => {
  const soma = base
    .split("")
    .reduce((total, char, index) => total + valorCnpjAlfa(char) * pesos[index], 0);

  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
};

const validarCpf = (valor) => {
  const cpf = normalizarSomenteNumeros(valor);

  if (!/^\d{11}$/.test(cpf)) return false;
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  const calc = (base) => {
    let soma = 0;
    for (let i = 0; i < base; i += 1) {
      soma += Number(cpf[i]) * (base + 1 - i);
    }
    const resto = (soma * 10) % 11;
    return resto === 10 ? 0 : resto;
  };

  return calc(9) === Number(cpf[9]) && calc(10) === Number(cpf[10]);
};

const validarCnpjAlfanumerico = (valor) => {
  const cnpj = normalizarDocumentoFiscal(valor);

  if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false;
  if (/^0{14}$/.test(cnpj)) return false;

  const pesosPrimeiroDigito = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const pesosSegundoDigito = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const base12 = cnpj.slice(0, 12);
  const primeiroDigito = calcularDigitoCnpjAlfa(base12, pesosPrimeiroDigito);
  const segundoDigito = calcularDigitoCnpjAlfa(
    `${base12}${primeiroDigito}`,
    pesosSegundoDigito,
  );

  return cnpj === `${base12}${primeiroDigito}${segundoDigito}`;
};

const validarCpfCnpjFiscal = (valor) => {
  const documento = normalizarDocumentoFiscal(valor);
  const somenteNumeros = normalizarSomenteNumeros(valor);

  if (!documento) {
    return {
      valido: false,
      tipo: "",
      documento: "",
      mensagem: "Informe CPF ou CNPJ.",
    };
  }

  if (/^\d{11}$/.test(somenteNumeros) && documento === somenteNumeros) {
    return {
      valido: validarCpf(somenteNumeros),
      tipo: "CPF",
      documento: somenteNumeros,
      mensagem: validarCpf(somenteNumeros) ? "" : "CPF inválido.",
    };
  }

  if (/^[A-Z0-9]{14}$/.test(documento)) {
    return {
      valido: validarCnpjAlfanumerico(documento),
      tipo: "CNPJ",
      documento,
      mensagem: validarCnpjAlfanumerico(documento)
        ? ""
        : "CNPJ inválido. Informe 14 posições alfanuméricas com dígitos verificadores válidos.",
    };
  }

  return {
    valido: false,
    tipo: "",
    documento,
    mensagem: "Documento inválido. CPF deve ter 11 números; CNPJ deve ter 14 posições alfanuméricas.",
  };
};

const formatarDocumentoFiscal = (valor) => {
  const documento = normalizarDocumentoFiscal(valor);

  if (/^\d{11}$/.test(documento)) {
    return documento.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  if (/^\d{14}$/.test(documento)) {
    return documento.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  }

  return documento;
};

const formatarDataCadastro = (valor) => {
  if (!valor) return "";

  const texto = String(valor).trim();

  const iso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;

  const br = texto.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (br) return `${br[1]}/${br[2]}/${br[3]}`;

  const data = new Date(valor);
  return Number.isNaN(data.getTime()) ? texto : data.toLocaleDateString("pt-BR");
};

const parseValorMonetario = (valor) => {
  if (valor == null) return null;

  let texto = String(valor).trim();

  if (!texto) return null;

  texto = texto.replace(/[^\d.,-]/g, "");

  if (!texto) return null;

  const temVirgula = texto.includes(",");
  const temPonto = texto.includes(".");

  if (temVirgula && temPonto) {
    if (texto.lastIndexOf(",") > texto.lastIndexOf(".")) {
      // 1.240,50
      texto = texto.replace(/\./g, "").replace(",", ".");
    } else {
      // 1,240.50
      texto = texto.replace(/,/g, "");
    }
  } else if (temVirgula) {
    // 240,50
    texto = texto.replace(",", ".");
  }
  // Somente ponto: 240.50 -> mantém como decimal.

  const numero = Number(texto);

  return Number.isFinite(numero) ? numero : null;
};

const formatarValorMonetario = (valor) => {
  const numero = parseValorMonetario(valor);

  if (numero == null) return "";

  return numero.toFixed(2).replace(".", ",");
};

const getNfseObrigatoria = (src = {}) =>
  toBoolFlag(
    src.NFSe_Obrigatoria ??
      src.nfseObrigatoria ??
      src.emissaoObrigatoria ??
      src.clienteObrigatorio ??
      src.obrigatorioNfse,
  );



const normalizarParametroLegado = (valor) =>
  String(valor ?? "")
    .trim()
    .toUpperCase();

const getCodigoTecnicoCatalogo = (catalogo = {}) =>
  String(
    catalogo.COD_PARAMETRO_TECNICO ??
      catalogo.codParametroTecnico ??
      catalogo.codigoTecnico ??
      "",
  ).trim();

const getNumeroParametroLegadoCatalogo = (catalogo = {}) =>
  String(
    catalogo.NM_PARAMETRO_LEGADO ??
      catalogo.nmParametroLegado ??
      catalogo.NR_PARAMETRO_LEGADO ??
      catalogo.nrParametroLegado ??
      "",
  ).trim();

const getGrupoParametroLegadoCatalogo = (catalogo = {}) =>
  String(
    catalogo.GRUPO_PARAMETRO_LEGADO ?? catalogo.grupoParametroLegado ?? "",
  ).trim();

const getNivelMutacaoCatalogo = (catalogo = {}) =>
  Number(catalogo.NIVEL_MUTACAO ?? catalogo.nivelMutacao ?? 1) || 1;

const flagSim = (valor) =>
  String(valor ?? "").trim().toUpperCase() === "S";

const parametroExigeJustificativa = (catalogo = {}) =>
  flagSim(catalogo.EXIGE_JUSTIFICATIVA ?? catalogo.exigeJustificativa) ||
  getNivelMutacaoCatalogo(catalogo) >= 2;

const parametroExigeConfirmacao = (catalogo = {}) =>
  flagSim(
    catalogo.EXIGE_CONFIRMACAO_TEXTUAL ?? catalogo.exigeConfirmacaoTextual,
  ) || getNivelMutacaoCatalogo(catalogo) >= 3;

const getFraseConfirmacaoCatalogo = (catalogo = {}) => {
  const frase = String(
    catalogo.FRASE_CONFIRMACAO ?? catalogo.fraseConfirmacao ?? "",
  ).trim();

  if (frase) return frase;

  if (getNivelMutacaoCatalogo(catalogo) >= 5) {
    return "CONFIRMO ALTERACAO CRITICA NIVEL 5";
  }

  return `CONFIRMO ALTERAR ${getCodigoTecnicoCatalogo(catalogo)}`;
};

const normalizarPerfilGovernanca = (valor) => {
  const perfil = String(valor ?? "").trim().toUpperCase();

  if (["ADM", "ADMIN", "ADMINISTRADOR"].includes(perfil)) return "ADMIN";
  if (["MASTER", "ADM_MASTER"].includes(perfil)) return "MASTER";
  if (["SUPERVISOR", "COORDENADOR"].includes(perfil)) return "SUPERVISOR";

  return perfil || "SUPORTE";
};

const getUsuarioGovernancaStorage = () =>
  String(
    sessionStorage.getItem("NomeFunc") ||
      sessionStorage.getItem("RazaoSocial") ||
      sessionStorage.getItem("Usuario") ||
      localStorage.getItem("NomeFunc") ||
      localStorage.getItem("RazaoSocial") ||
      "Sistema",
  ).trim() || "Sistema";

const normalizarNivelParametro = (valor) => {
  const nivel = Number(valor);

  if (!Number.isInteger(nivel) || nivel < 0 || nivel > 5) {
    return 0;
  }

  return nivel;
};

const getNivelParametroStorage = () => {
  const direto =
    sessionStorage.getItem("NivelParametro") ??
    sessionStorage.getItem("nivelParametro") ??
    localStorage.getItem("NivelParametro") ??
    localStorage.getItem("nivelParametro");

  if (direto !== null && String(direto).trim() !== "") {
    return normalizarNivelParametro(direto);
  }

  try {
    const user = JSON.parse(
      sessionStorage.getItem("user") ||
      localStorage.getItem("user") ||
      "{}"
    );

    return normalizarNivelParametro(
      user.NivelParametro ?? user.nivelParametro ?? 0
    );
  } catch {
    return 0;
  }
};

const garantirBearerApi = () => {
  const token =
    sessionStorage.getItem("token") ||
    localStorage.getItem("token") ||
    "";

  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  return token;
};

const CadastroTela = () => {
  const mostrarRestricaoOrigRef = useRef("false");
  const selectReqRef = useRef(0);
  const clienteUrlProcessadoRef = useRef(false);
  const toastControleRef = useRef({ chave: "", criadoEm: 0 });

  const mostrarToastControlado = useCallback((tipo, mensagem, options = {}) => {
    const texto = String(mensagem ?? "").trim();
    if (!texto) return null;

    const agora = Date.now();
    const chave = `${tipo}:${texto}`;

    // Evita empilhamento quando a mesma ação dispara a mesma mensagem em sequência.
    if (
      toastControleRef.current.chave === chave &&
      agora - toastControleRef.current.criadoEm < 1500
    ) {
      return null;
    }

    toastControleRef.current = { chave, criadoEm: agora };

    const config = {
      autoClose: tipo === "error" ? 7000 : 4000,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      ...options,
    };

    return tipo === "error" ? toastError(texto, config) : toastInfo(texto, config);
  }, []);

  const showInfo = useCallback(
    (mensagem, options = {}) => mostrarToastControlado("info", mensagem, options),
    [mostrarToastControlado],
  );

  const showError = useCallback(
    (mensagem, options = {}) => mostrarToastControlado("error", mensagem, options),
    [mostrarToastControlado],
  );

  const [tabAtiva, setTabAtiva] = useState("cadastro");
  const [form, setForm] = useState({
    tipo: "",
    codigo: "",
    dtCad: "",
    dataReativacao: "",
    razaoSocial: "",
    nomeFantasia: "",
    cnpj: "",
    cep: "",
    rua: "",
    bairro: "",
    numero: "",
    cidade: "",
    UF: "",
    pais: "Brasil",
    telefone: "",
    responsavel: "",
    celular: "",
    email: "",
    emailContador: "",
    rgIe: "",
    complemento: "",
    codmun: "",
    Obs: "",
    restricoes: "",
    mostrarRestricao: "false",
    desativado: "false",
    comercio: "",
    vencto: "",
    imposto: "",
    liberacao: "",
    Boleto_Fisico_Digital: "1",
    TipoPdv: "",
    tempoNegociacao: "",
    autorizacao: "",
    tokenLicenca: "", // 🔹 NOVO
    NFSe_Obrigatoria: false,
    NFSe_Email: "",
    NFSe_Obs: "",
  });

  const [empresasLicenca, setEmpresasLicenca] = useState([]);
  const [loadingEmpresas, setLoadingEmpresas] = useState(false);
  const [referenciaFiscal, setReferenciaFiscal] = useState("");
  const [enviandoFiscal, setEnviandoFiscal] = useState(false);
  const [exportandoXmlCupom, setExportandoXmlCupom] = useState(false);
  const [periodoXmlCupom, setPeriodoXmlCupom] = useState(() => {
    const hoje = new Date();
    const pad = (valor) => String(valor).padStart(2, "0");
    const formatar = (data) =>
      `${data.getFullYear()}-${pad(data.getMonth() + 1)}-${pad(data.getDate())}`;

    return {
      de: formatar(new Date(hoje.getFullYear(), hoje.getMonth(), 1)),
      ate: formatar(hoje),
    };
  });
  const [imendesLoadingEmpresaId, setImendesLoadingEmpresaId] = useState(null);
  const [imendesHabilitandoLicenca, setImendesHabilitandoLicenca] = useState(false);
  const [imendesSincronizandoProdutos, setImendesSincronizandoProdutos] = useState(false);
  const [imendesSincronizacaoProgresso, setImendesSincronizacaoProgresso] = useState(null);
  const [imendesStatusLoading, setImendesStatusLoading] = useState(false);
  const [imendesStatusEmpresas, setImendesStatusEmpresas] = useState({});
  const [imendesResultado, setImendesResultado] = useState(null);

  const [empresaModalOpen, setEmpresaModalOpen] = useState(false);
  const [empresaForm, setEmpresaForm] = useState({
    id: "",
    nrLicenca: "",
    razaoSocial: "",
    nomeFantasia: "",
    cnpj: "",
    rgIe: "",
    email: "",
    telefone: "",
    cep: "",
    rua: "",
    numero: "",
    bairro: "",
    cidade: "",
    UF: "",
    complemento: "",
  });

  const [loadingEmpresa, setLoadingEmpresa] = useState(false);

  // futuro: usuários por empresa (apenas layout por enquanto)
  const [usuariosEmpresa, setUsuariosEmpresa] = useState([]);

  const headerChkRef = useRef(null);
  const [showRestricaoModal, setShowRestricaoModal] = useState(false);
  const [ultimoCodigoComAviso, setUltimoCodigoComAviso] = useState(null);

  useEffect(() => {
    if (!showRestricaoModal) return undefined;

    const handleEscapeAviso = (event) => {
      if (event.key === "Escape") setShowRestricaoModal(false);
    };

    window.addEventListener("keydown", handleEscapeAviso);
    return () => window.removeEventListener("keydown", handleEscapeAviso);
  }, [showRestricaoModal]);

  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [copiedGuid, setCopiedGuid] = useState(null);
  const [nivelFunc, setNivelFunc] = useState("");
  const [nivelParametroUsuario, setNivelParametroUsuario] = useState(0);
  const [setor, setSetor] = useState("");
  const canVerBoletos = useMemo(() => {
    const n = (nivelFunc || "").toUpperCase();
    const s = (setor || "").toUpperCase();
    return s === "FINANCEIRO" || n === "ADM";
  }, [nivelFunc, setor]);

  const canGerenciarImendes = useMemo(() => {
    const perfil = normalizarPerfilGovernanca(nivelFunc);
    const nivel = String(nivelFunc || "").trim().toUpperCase();

    return perfil === "ADMIN" || perfil === "MASTER" || nivel === "ADM";
  }, [nivelFunc]);

  const [loadingCep, setLoadingCep] = useState(false);
  const [loadingCnpj, setLoadingCnpj] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [statusCancelamento, setStatusCancelamento] = useState(""); // andamento do cancelamento
  const [planoSelecionado, setPlanoSelecionado] = useState(null);
  const [showModalEditarPlano, setShowModalEditarPlano] = useState(false);
  const [showConfirmExcluirPlano, setShowConfirmExcluirPlano] = useState(false);
  const [loadingSwitch, setLoadingSwitch] = useState(false);
  const [updatingGuid, setUpdatingGuid] = useState(null);
  const [infoCadastro, setInfoCadastro] = useState({
    planos: [],
    parcelas: [],
    recorrenciaChamados: [],
  });
  const [comercios, setComercios] = useState([]);
  const [impostos, setImpostos] = useState([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [computadores, setComputadores] = useState([]);
  const [certificados, setCertificados] = useState([]);
  const [showModalPlanos, setShowModalPlanos] = useState(false);
  const [semCertificado, setSemCertificado] = useState(false);
  const [camposCertificadoDesabilitados, setCamposCertificadoDesabilitados] =
    useState(false);
  const [modoEdicaoPlanoId, setModoEdicaoPlanoId] = useState(null);
  const [valorEdicao, setValorEdicao] = useState("");
  const [dadosCertificado, setDadosCertificado] = useState({
    nomeCertificado: "",
    senha: "",
    arquivo: null,
  });
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [definindoCertEmissorId, setDefinindoCertEmissorId] = useState(null);

  const cadastroAtualEhEmitenteNfse = useMemo(
    () => String(form.codigo || "").trim() === CODIGO_EMITENTE_NFSE,
    [form.codigo],
  );

  const camposObrigatorios = [
    { nome: "cnpj", label: "CPF/CNPJ" },
    { nome: "responsavel", label: "Responsável" },
    { nome: "telefone", label: "Telefone" },
    { nome: "cidade", label: "Cidade" },
    { nome: "email", label: "E-mail" },
    { nome: "tipo", label: "Tipo de Cadastro" },
    { nome: "crt", label: "CRT" },
    { nome: "razaoSocial", label: "Razão Social" },
    { nome: "nomeFantasia", label: "Nome Fantasia" },
    { nome: "rgIe", label: "RG/IE" },
    { nome: "NumMaquina", label: "Nº de Máquinas" },
    { nome: "cep", label: "CEP" },
    { nome: "pais", label: "País" },
    { nome: "UF", label: "Estado" },
    { nome: "codmun", label: "Código do Município" },
    { nome: "bairro", label: "Bairro" },
    { nome: "rua", label: "Endereço" },
    { nome: "numero", label: "Número" },
    { nome: "celular", label: "Celular" },
    { nome: "liberacao", label: "Liberação" },
    { nome: "vencto", label: "Dia de Vencimento" },
    { nome: "imposto", label: "Grupo de Imposto" },
  ];

  const isClienteCanceladoForm = (f) =>
    f.tipo === "Cliente Desistente" ||
    f.desativado === "true" ||
    String(f.liberacao || "").toUpperCase() === "B";

  const aplicarRegrasNegociacaoECancelamento = (
    draft,
    campoAlterado,
    valor,
  ) => {
    const norm = (x) => (x == null ? "" : String(x));

    // NEGOCIAÇÃO
    if (
      campoAlterado === "tipo" &&
      norm(valor).toLowerCase() === "cliente negociacao"
    ) {
      draft.tipo = "Cliente Negociacao";
      draft.liberacao = "G";
      draft.tempoNegociacao = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
        .toISOString()
        .split("T")[0];
    }

    if (campoAlterado === "liberacao" && norm(valor).toUpperCase() === "G") {
      draft.tipo = "Cliente Negociacao";
      draft.liberacao = "G";
      draft.tempoNegociacao = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
        .toISOString()
        .split("T")[0];
    }

    // CANCELAMENTO
    const campoLevouParaCancelado =
      (campoAlterado === "tipo" &&
        norm(valor).toLowerCase() === "cliente desistente") ||
      (campoAlterado === "desativado" &&
        norm(valor).toLowerCase() === "true") ||
      (campoAlterado === "liberacao" && norm(valor).toUpperCase() === "B");

    if (campoLevouParaCancelado) {
      draft.tipo = "Cliente Desistente";
      draft.desativado = "true";
      draft.liberacao = "B";
      draft.tempoNegociacao = "";
      return draft;
    }

    // REATIVAÇÃO (estado do form)
    const campoLevouParaAtivo =
      (campoAlterado === "tipo" &&
        norm(valor).toLowerCase() === "cliente de software") ||
      (campoAlterado === "desativado" &&
        norm(valor).toLowerCase() === "false") ||
      (campoAlterado === "liberacao" && norm(valor).toUpperCase() === "N");

    if (campoLevouParaAtivo) {
      draft.tipo = "Cliente de software";
      draft.desativado = "false";
      draft.liberacao = "N";
      draft.tempoNegociacao = "";
      return draft;
    }

    return draft;
  };

  // busca cliente completo (fallback de shape + fallback de rota)
  const fetchClienteFull = async (id) => {
    const cod = String(id || "").trim();
    if (!cod) return null;

    const { data } = await api.get(`/ssw/cliente/${cod}`);
    return data?.cliente || data || null;
  };

  const reativarClienteTela = async () => {
    if (!form.codigo) {
      showError("Carregue um cliente.");
      return;
    }

    try {
      await api.patch(`/cliente/${form.codigo}/reativar`);

      const reqId = ++selectReqRef.current;
      const cli = await fetchClienteFull(form.codigo);

      if (!cli) {
        showError("Cliente reativado, mas falhou ao recarregar dados.");
        return;
      }

      prepararEstadoBasicoCliente(cli);
      await hydrateClienteSelecionado(String(form.codigo), reqId);

      setStatusCancelamento("");
      showInfo("Cliente reativado com sucesso.");
    } catch (e) {
      console.error(e);
      showError("Falha ao reativar cliente.");
    }
  };

  useEffect(() => {
    if (tabAtiva === "boletos" && !canVerBoletos) {
      setTabAtiva("cadastro");
      setBoletosHabilitados(false);
      resetBoletosTab();
    }
  }, [canVerBoletos, tabAtiva]);

  useEffect(() => {
    const codigo = form?.codigo;
    const mostrar =
      String(form?.mostrarRestricao ?? "").toLowerCase() === "true";
    const texto = (form?.restricoes || "").trim();
    if (mostrarRestricaoOrigRef.current !== "true") return;
    if (!codigo || !mostrar || !texto) return;
    if (ultimoCodigoComAviso === codigo) return; // já exibido para este código
    setShowRestricaoModal(true);
    setUltimoCodigoComAviso(codigo);
  }, [form.codigo, form.mostrarRestricao, form.restricoes, ultimoCodigoComAviso]);

  const [boletos, setBoletos] = useState([]);
  const [totalBoletos, setTotalBoletos] = useState(0);
  const [loadingBoletos, setLoadingBoletos] = useState(false);
  const [selectedGuids, setSelectedGuids] = useState(new Set());
  const [confirmLoteOpen, setConfirmLoteOpen] = useState(false);
  const [novaSituacaoLote, setNovaSituacaoLote] = useState("");
  const [boletosHabilitados, setBoletosHabilitados] = useState(false);
  const [resumoBoletos, setResumoBoletos] = useState(DEFAULT_RESUMO);
  const [filtroBoleto, setFiltroBoleto] = useState(DEFAULT_FILTRO_BOLETO);

  // Modal específico para cancelamento (boletos pendentes)
  const [cancelBoletosModalOpen, setCancelBoletosModalOpen] = useState(false);
  const [cancelBoletosLista, setCancelBoletosLista] = useState([]);
  const [cancelBoletosSelecionados, setCancelBoletosSelecionados] = useState(
    new Set(),
  );
  const [cancelBoletosLoading, setCancelBoletosLoading] = useState(false);
  const [loadingComputadores, setLoadingComputadores] = useState(false);
  const [pcSelecionado, setPcSelecionado] = useState(null);
  const [paramModalOpen, setParamModalOpen] = useState(false);
  const [paramLoading, setParamLoading] = useState(false);
  const [paramSaving, setParamSaving] = useState(false);
  const [paramList, setParamList] = useState([]); // lista completa do pc
  const [paramEdit, setParamEdit] = useState({}); // chave -> novo VL_PARAMETRO
  const [maquinaClienteInfo, setMaquinaClienteInfo] = useState({
    loading: false,
    deleting: false,
    idMaquinaCliente: null,
    erro: "",
    atualizadoEm: null,
  });

  const [paramSearch, setParamSearch] = useState("");
  const [paramSearchMode, setParamSearchMode] = useState("all"); // all | grupo | param
  const [paramSort, setParamSort] = useState({
    key: "GRUPO_PARAMETRO",
    dir: "asc",
  });
  const [paramGovernancaCatalogo, setParamGovernancaCatalogo] = useState([]);
  const [paramGovernancaLoading, setParamGovernancaLoading] = useState(false);
  const [paramGovernancaJustificativa, setParamGovernancaJustificativa] =
    useState("");
  const [paramGovernancaConfirmacao, setParamGovernancaConfirmacao] =
    useState("");
  const [paramGovernancaResultado, setParamGovernancaResultado] = useState(null);

  const hydrateClienteSelecionado = async (codigo, reqId) => {
    const [resCliente, resInfoCad] = await Promise.allSettled([
      api.get(`/ssw/cliente/${codigo}`),
      api.get(`/cliente/infoCad`, { params: { codigo } }),
    ]);

    if (reqId !== selectReqRef.current) return;

    if (resCliente.status === "fulfilled") {
      const full = resCliente.value?.data || {};
      const clienteBase = full?.cliente || null;

      if (clienteBase) {
        setClienteSelecionado(clienteBase);
        setForm((prev) => mergeClienteNoForm(clienteBase, prev));
      }

      const listaEmpresasEntrada = Array.isArray(full?.empresasEntrada)
        ? full.empresasEntrada
        : [];

      setEmpresasLicenca(listaEmpresasEntrada);
      await carregarStatusImendesEmpresas(listaEmpresasEntrada, codigo);
    }

    if (resInfoCad.status === "fulfilled") {
      setInfoCadastro(
        resInfoCad.value?.data || {
          planos: [],
          parcelas: [],
          recorrenciaChamados: [],
        },
      );
    } else {
      setInfoCadastro({
        planos: [],
        parcelas: [],
        recorrenciaChamados: [],
      });
    }
  };

  const prepararEstadoBasicoCliente = (cliente) => {
    const codigo = String(cliente?.CodigoCad || "").trim();
    if (!codigo) return "";

    setClienteSelecionado(cliente);

    setForm((prev) =>
      mergeClienteNoForm(
        {
          ...cliente,
          CodigoCad: codigo,
        },
        prev,
      ),
    );

    setBoletosHabilitados(!!codigo && canVerBoletos);
    setFiltroBoleto((prevF) => ({
      ...prevF,
      nrLicenca: codigo,
      page: 1,
    }));

    return codigo;
  };

  useEffect(() => {
    if (clienteUrlProcessadoRef.current) return;
    clienteUrlProcessadoRef.current = true;

    const params = new URLSearchParams(window.location.search || "");
    const codigoUrl = String(
      params.get("codigo") || params.get("CodigoCad") || "",
    ).trim();

    if (!codigoUrl) return;

    const carregarClienteDaUrl = async () => {
      try {
        const reqId = ++selectReqRef.current;
        const cliente = await fetchClienteFull(codigoUrl);

        if (!cliente) {
          showError("Cliente não encontrado para o código informado na URL.");
          return;
        }

        const codigo = prepararEstadoBasicoCliente({
          ...cliente,
          CodigoCad: cliente?.CodigoCad || codigoUrl,
        });

        if (!codigo) return;

        await hydrateClienteSelecionado(codigo, reqId);
      } catch (err) {
        console.error("Erro ao carregar cliente pela URL:", err);
        showError("Erro ao carregar cliente informado na URL.");
      }
    };

    carregarClienteDaUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleSort = (key) => {
    setParamSort((prev) => {
      if (prev.key === key) {
        return { key, dir: prev.dir === "asc" ? "desc" : "asc" };
      }
      return { key, dir: "asc" };
    });
  };

  const sortIcon = (key) => {
    if (paramSort.key !== key) return "↕";
    return paramSort.dir === "asc" ? "↑" : "↓";
  };

  const normalize = (v) =>
    String(v ?? "")
      .toLowerCase()
      .trim();

  const resetBoletosTab = () => {
    setBoletosHabilitados(false);
    setFiltroBoleto(DEFAULT_FILTRO_BOLETO);
    setResumoBoletos(DEFAULT_RESUMO);
    setBoletos([]);
    setTotalBoletos(0);
    setSelectedGuids(new Set());
    setNovaSituacaoLote("");
    setConfirmLoteOpen(false);
  };

  const getFiscalExportUrl = () => {
    // base configurada no api.js (origin, SEM /ssw)
    if (typeof window !== "undefined" && window.__AXIOS__?.baseURL) {
      return `${window.__AXIOS__.baseURL}/fiscal-export/manual-run-licenca`;
    }

    // fallback para produção
    return "https://apisantsystemweb30git-production-318e.up.railway.app/fiscal-export/manual-run-licenca";
  };

  const setGuidChecked = (guid, checked) => {
    setSelectedGuids((prev) => {
      const n = new Set(prev);
      if (checked) n.add(guid);
      else n.delete(guid);
      return n;
    });
  };
  const setAllOnPage = (checked) => {
    setSelectedGuids((prev) => {
      const n = new Set(prev);
      boletos.forEach((b) =>
        checked ? n.add(b.GUID_BOLETO) : n.delete(b.GUID_BOLETO),
      );
      return n;
    });
  };


  const fmtBRL = (v) => {
    const n = Number(String(v).replace(",", "."));
    return isNaN(n)
      ? "-"
      : n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };
  const badgeClass = (s) =>
    s === "Quitado"
      ? "badge badge-green"
      : s === "Pendente"
        ? "badge badge-amber"
        : "badge badge-red";

  const situacoesSelecionadas = useMemo(
    () =>
      Object.entries(filtroBoleto.situacoes)
        .filter(([, v]) => v)
        .map(([k]) => k),
    [filtroBoleto.situacoes],
  );

  const hasFiltroForte = useMemo(() => {
    const situacaoAperta =
      situacoesSelecionadas.length > 0 && situacoesSelecionadas.length < 3;

    return Boolean(
      filtroBoleto.nrLicenca ||
        filtroBoleto.de ||
        filtroBoleto.ate ||
        filtroBoleto.search ||
        filtroBoleto.minValor ||
        filtroBoleto.maxValor ||
        situacaoAperta,
    );
  }, [
    filtroBoleto.nrLicenca,
    filtroBoleto.de,
    filtroBoleto.ate,
    filtroBoleto.search,
    filtroBoleto.minValor,
    filtroBoleto.maxValor,
    situacoesSelecionadas,
  ]);

  const buildQuery = useCallback(
    (withPaging = true) => {
      const p = new URLSearchParams();
      if (filtroBoleto.nrLicenca)
        p.set("nrLicenca", String(filtroBoleto.nrLicenca));
      if (filtroBoleto.de) p.set("de", filtroBoleto.de);
      if (filtroBoleto.ate) p.set("ate", filtroBoleto.ate);
      if (filtroBoleto.search) p.set("search", filtroBoleto.search.trim());
      if (filtroBoleto.minValor)
        p.set("minValor", String(filtroBoleto.minValor).replace(",", "."));
      if (filtroBoleto.maxValor)
        p.set("maxValor", String(filtroBoleto.maxValor).replace(",", "."));

      if (situacoesSelecionadas.length && situacoesSelecionadas.length < 3) {
        p.set("situacoes", situacoesSelecionadas.join(","));
      }

      if (withPaging) {
        p.set("page", String(filtroBoleto.page));
        p.set("limit", String(filtroBoleto.limit));
      }

      return p.toString();
    },
    [
      filtroBoleto.nrLicenca,
      filtroBoleto.de,
      filtroBoleto.ate,
      filtroBoleto.search,
      filtroBoleto.minValor,
      filtroBoleto.maxValor,
      filtroBoleto.page,
      filtroBoleto.limit,
      situacoesSelecionadas,
    ],
  );

  const fetchResumo = useCallback(async () => {
    if (!boletosHabilitados || tabAtiva !== "boletos") return;

    if (!hasFiltroForte) {
      setResumoBoletos(DEFAULT_RESUMO);
      return;
    }

    try {
      const { data } = await api.get(`/boletos/resumo?${buildQuery(false)}`);
      setResumoBoletos(data || DEFAULT_RESUMO);
    } catch (e) {
      console.error(e);
      showError(getApiErrorMessage(e, "Falha ao carregar resumo dos boletos."));
      setResumoBoletos(DEFAULT_RESUMO);
    }
  }, [boletosHabilitados, tabAtiva, hasFiltroForte, buildQuery, showError]);

  const fetchBoletos = useCallback(async () => {
    if (!boletosHabilitados || tabAtiva !== "boletos") return;

    if (!hasFiltroForte) {
      setBoletos([]);
      setTotalBoletos(0);
      return;
    }

    setLoadingBoletos(true);

    try {
      const { data } = await api.get(`/boletos?${buildQuery(true)}`);
      setBoletos(data?.data || []);
      setTotalBoletos(data?.total || 0);
      setSelectedGuids(new Set());
    } catch (e) {
      console.error(e);
      showError(getApiErrorMessage(e, "Falha ao listar boletos."));
      setBoletos([]);
      setTotalBoletos(0);
    } finally {
      setLoadingBoletos(false);
    }
  }, [boletosHabilitados, tabAtiva, hasFiltroForte, buildQuery, showError]);

  useEffect(() => {
    const t = setTimeout(() => {
      fetchResumo();
    }, 350);

    return () => clearTimeout(t);
  }, [fetchResumo]);

  useEffect(() => {
    const t = setTimeout(() => {
      fetchBoletos();
    }, 350);

    return () => clearTimeout(t);
  }, [fetchBoletos]);


  const aplicarSituacaoSingle = async (guid, situacao) => {
    setUpdatingGuid(guid);
    try {
      await api.patch(`/boletos/${guid}/situacao`, { situacao });
      showInfo("Situação atualizada.");
    } catch (e) {
      console.error(e);
      showError("Falha ao atualizar situação.");
    } finally {
      setUpdatingGuid(null);
      fetchResumo();
      fetchBoletos();
    }
  };

  const aplicarSituacaoLote = async () => {
    if (!novaSituacaoLote) return showError("Selecione a situação.");
    if (selectedGuids.size === 0)
      return showError("Selecione ao menos um boleto.");
    try {
      await api.patch(`/boletos/situacao/lote`, {
        situacao: novaSituacaoLote,
        guids: Array.from(selectedGuids),
      });
      showInfo("Situação atualizada em lote.");
      setConfirmLoteOpen(false);
      setSelectedGuids(new Set());
      fetchResumo();
      fetchBoletos();
    } catch (e) {
      console.error(e);
      showError("Falha no lote.");
    }
  };
  const onChangeFiltro = (k, v) =>
    setFiltroBoleto((prev) => ({
      ...prev,
      [k]: v,
      page: k === "page" ? v : 1,
    }));

  const totalPages = useMemo(
    () =>
      Math.max(1, Math.ceil(totalBoletos / Math.max(1, filtroBoleto.limit))),
    [totalBoletos, filtroBoleto.limit],
  );

  useEffect(() => {
    if (filtroBoleto.page > totalPages) {
      setFiltroBoleto((prev) => ({ ...prev, page: totalPages }));
    }
  }, [filtroBoleto.page, totalPages]);

  useEffect(() => {
    garantirBearerApi();
    setNivelFunc(sessionStorage.getItem("NivelFunc") || "");
    setNivelParametroUsuario(getNivelParametroStorage());
    setSetor(sessionStorage.getItem("Setor") || "");
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "cnpj") {
      setForm((prev) => ({
        ...prev,
        cnpj: normalizarDocumentoFiscal(value),
      }));
      return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // pode remover completamente a função mapEmpresaToForm, não será mais usada

  const handleGerenciarEmpresa = (emp) => {
    console.log("emp (empresa selecionada) =>", emp);
    // mapeia o que vier da API
    const mapped = mapEmpresaApiToForm(emp);

    // tenta pegar licença do próprio registro ou da tela de cadastro
    const nrLicencaApi =
      mapped.nrLicenca ||
      emp.nr_licenca ||
      emp.NR_LICENCA ||
      emp.nrLicenca ||
      "";

    const nrLicencaTela = String(form.codigo || "").trim();

    setEmpresaForm({
      ...mapped,
      nrLicenca: nrLicencaApi || nrLicencaTela, // garante que nunca fique vazio
    });

    setEmpresaModalOpen(true);
  };

  const handleIncluirEmpresa = () => {
    // monta o form no mesmo formato do useState inicial
    setEmpresaForm({
      id: "",
      nrLicenca: String(form.codigo || ""),
      razaoSocial: "",
      nomeFantasia: "",
      cnpj: "",
      rgIe: "",
      email: "",
      telefone: "",
      cep: "",
      rua: "",
      numero: "",
      bairro: "",
      cidade: "",
      UF: "",
      complemento: "",
    });

    setEmpresaModalOpen(true);
  };

  useEffect(() => {
    if (!certificados || certificados.length === 0) return;
    const clienteSemCert = certificados.some(
      (cert) => cert?.NomeCertificado?.toUpperCase() === "SEM_CERTIFICADO",
    );
    setSemCertificado(clienteSemCert);
    setCamposCertificadoDesabilitados(clienteSemCert);
  }, [certificados]);

  const carregarCertificados = async () => {
    if (!form.codigo) return;
    try {
      const { data: lista = [] } = await api.get(`/certificado/${form.codigo}`);
      setCertificados(lista);
    } catch (error) {
      showError("Erro ao buscar certificados do cliente.");
    }
  };

  const atualizarDadosCliente = async () => {
    const codigoCliente = String(form.codigo || "").trim();
    if (!codigoCliente) {
      showError("Código do cliente não encontrado.");
      return;
    }

    try {
      const reqId = ++selectReqRef.current;
      await hydrateClienteSelecionado(codigoCliente, reqId);
    } catch (err) {
      console.error(err);
      showError("Erro ao atualizar dados do cliente.");
    }
  };

  const handleSalvarEdicaoPlano = async (id) => {
    const valorCobrado = formatarValorMonetario(valorEdicao);
    const numero = parseValorMonetario(valorCobrado);

    if (!valorCobrado || numero == null || numero <= 0) {
      showError("Informe um valor válido.");
      return;
    }

    try {
      await api.put(`/ClientesPlanos/plano/${id}`, {
        // Mantém vírgula para compatibilidade com o banco/sistema legado.
        ValorCobrado: valorCobrado,
      });

      showInfo("Plano atualizado com sucesso.");
      atualizarDadosCliente();
      setModoEdicaoPlanoId(null);
    } catch {
      showError("Erro ao atualizar plano.");
    }
  };

  const handleChangeEmpresaForm = (campo, valor) => {
    setEmpresaForm((prev) => ({
      ...prev,
      [campo]: campo === "cnpj" ? normalizarDocumentoFiscal(valor) : valor,
    }));
  };

  const handleSalvarEmpresa = async () => {
    if (!empresaForm.nrLicenca) {
      showError("Licença não informada para a empresa.");
      return;
    }

    const documentoEmpresa = validarCpfCnpjFiscal(empresaForm.cnpj);

    if (!documentoEmpresa.valido) {
      showError(documentoEmpresa.mensagem);
      return;
    }

    try {
      const payload = {
        nr_licenca: empresaForm.nrLicenca,
        RazaoSocial: empresaForm.razaoSocial,
        NomeFant: empresaForm.nomeFantasia,
        CpfCnpj: documentoEmpresa.documento,
        RgIe: empresaForm.rgIe,
        Email: empresaForm.email,
        Tel1: empresaForm.telefone,
        CEP: (empresaForm.cep || "").replace(/\D/g, ""),
        Endereco: empresaForm.rua,
        Numero: empresaForm.numero,
        Bairro: empresaForm.bairro,
        Cidade: empresaForm.cidade,
        UF: empresaForm.UF,
        Complemento: empresaForm.complemento,
      };

      console.log(">>>> payload empresa", payload);
      console.log(">>>> empresaForm.id", empresaForm.id);

      let resp;

      if (empresaForm.id) {
        // EDIÇÃO
        resp = await api.put(
          `/ssw/cliente/empresas/${empresaForm.id}`,
          payload,
        );
        showInfo("Dados da empresa atualizados com sucesso.");
      } else {
        // INCLUSÃO
        resp = await api.post(`/ssw/cliente/empresas`, payload);
        showInfo("Empresa incluída com sucesso.");
      }

      console.log(">>>> resposta API empresas", resp?.status, resp?.data);

      if (form.codigo) {
        await carregarEmpresasLicenca(form.codigo);
      }

      setEmpresaModalOpen(false);
    } catch (error) {
      console.error("Erro ao salvar empresa:", error);

      const msgApi =
        error?.response?.data?.mensagem ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Erro ao salvar dados da empresa.";

      showError(msgApi);
    }
  };

  const handleExcluirEmpresa = async () => {
    if (!empresaForm.id) {
      showError("Nenhuma empresa selecionada para exclusão.");
      return;
    }

    const ok = window.confirm(
      "Confirma a exclusão desta empresa vinculada à licença?",
    );
    if (!ok) return;

    try {
      setLoadingEmpresa(true);

      // endpoint que já está plugado na API de clientes
      await api.delete(`/ssw/cliente/empresas/${empresaForm.id}`);

      showInfo("Empresa excluída com sucesso.");

      // recarrega a grid da licença atual
      if (form.codigo) {
        await carregarEmpresasLicenca(form.codigo);
      }

      setEmpresaModalOpen(false);
    } catch (error) {
      console.error("Erro ao excluir empresa:", error);
      showError("Erro ao excluir empresa da licença.");
    } finally {
      setLoadingEmpresa(false);
    }
  };


  const getEmpresaImendesId = (emp = {}) =>
    emp.id ??
    emp.ID_EMPRESA ??
    emp.id_empresa ??
    emp.IdEmpresa ??
    emp.ID ??
    "";

  const getEmpresaImendesCampo = (emp = {}, chaves = []) => {
    for (const chave of chaves) {
      const valor = emp?.[chave];
      if (valor !== undefined && valor !== null && String(valor).trim() !== "") {
        return valor;
      }
    }

    return "";
  };

  const extrairNumeroCrt = (valor) => {
    const match = String(valor ?? "").match(/\d+/);
    const crt = Number(match?.[0] || 3);
    return [1, 2, 3].includes(crt) ? crt : 3;
  };

  const getEmpresaImendesStatusKey = (emp = {}) =>
    String(getEmpresaImendesId(emp) || "").trim();

  const getStatusImendesEmpresa = (emp = {}) => {
    const key = getEmpresaImendesStatusKey(emp);
    return key ? imendesStatusEmpresas[key] || null : null;
  };

  const getResumoStatusImendes = () => {
    const statuses = empresasLicenca
      .map((emp) => getStatusImendesEmpresa(emp))
      .filter(Boolean);

    return {
      carregando: imendesStatusLoading,
      totalEmpresas: empresasLicenca.length,
      totalStatus: statuses.length,
      temEmpresaImendes: statuses.some((st) => st.cadastradaNaImendes === true),
      saneamentoHabilitado: statuses.some((st) => st.saneamentoHabilitado === true),
      podeHabilitarSaneamento: statuses.some((st) => st.podeHabilitarSaneamento === true),
      possuiErroStatus: statuses.some((st) => st.erro === true),
    };
  };

  const carregarStatusImendesEmpresas = async (lista = [], nrLicencaParam = "") => {
    const nrLicenca = String(nrLicencaParam || form.codigo || "").trim();
    const empresas = Array.isArray(lista) ? lista : [];

    if (!nrLicenca || empresas.length === 0) {
      setImendesStatusEmpresas({});
      return {};
    }

    setImendesStatusLoading(true);

    try {
      const resultados = await Promise.allSettled(
        empresas.map(async (emp) => {
          const idEmpresa = getEmpresaImendesId(emp);
          const key = String(idEmpresa || "").trim();

          if (!key) {
            return null;
          }

          const { data } = await api.get(
            `/ssw/cliente/empresas/${idEmpresa}/imendes/status`,
            { params: { nrLicenca } },
          );

          return [key, data?.result || data || {}];
        }),
      );

      const mapa = {};

      resultados.forEach((item, index) => {
        const emp = empresas[index];
        const key = getEmpresaImendesStatusKey(emp);

        if (!key) return;

        if (item.status === "fulfilled" && item.value) {
          const [, status] = item.value;
          mapa[key] = {
            ...status,
            erro: false,
            carregado: true,
          };
        } else {
          mapa[key] = {
            erro: true,
            carregado: false,
            cadastradaNaImendes: false,
            saneamentoHabilitado: false,
            podeCadastrarImendes: false,
            podeHabilitarSaneamento: false,
            mensagem:
              item.reason?.response?.data?.message ||
              item.reason?.message ||
              "Falha ao consultar status IMendes.",
          };
        }
      });

      setImendesStatusEmpresas(mapa);
      return mapa;
    } catch (error) {
      console.error("Erro ao carregar status IMendes:", error);
      setImendesStatusEmpresas({});
      showError(getApiErrorMessage(error, "Falha ao consultar status IMendes."));
      return {};
    } finally {
      setImendesStatusLoading(false);
    }
  };

  const montarPayloadCadastroImendes = (emp = {}) => {
    const nrLicenca = String(form.codigo || "").trim();
    const idEmpresa = getEmpresaImendesId(emp) || 1;
    const documento = validarCpfCnpjFiscal(
      getEmpresaImendesCampo(emp, [
        "cpf_cnpj",
        "CpfCnpj",
        "CNPJ",
        "cnpj",
        "NR_CNPJ",
      ]),
    );

    if (!nrLicenca) {
      throw new Error("Carregue um cliente/licença antes de cadastrar na IMendes.");
    }

    if (!documento.valido || documento.tipo !== "CNPJ") {
      throw new Error(
        documento.mensagem || "A empresa precisa ter um CNPJ válido para cadastro na IMendes.",
      );
    }

    return {
      NR_LICENCA: nrLicenca,
      ID_EMPRESA: idEmpresa,
      CNPJ: documento.documento,
      RAZAO_SOCIAL: getEmpresaImendesCampo(emp, [
        "razao_social",
        "RazaoSocial",
        "RAZAO_SOCIAL",
        "razaoSocial",
      ]),
      NOME_FANTASIA: getEmpresaImendesCampo(emp, [
        "nome_fantasia",
        "NomeFant",
        "NOME_FANTASIA",
        "nomeFantasia",
      ]),
      IE: getEmpresaImendesCampo(emp, ["rg_ie", "RgIe", "IE", "RG_IE"]),
      EMAIL: getEmpresaImendesCampo(emp, ["email", "Email", "EMAIL"]),
      TELEFONE: getEmpresaImendesCampo(emp, ["tel1", "Tel1", "telefone", "Telefone"]),
      CEP: normalizarSomenteNumeros(getEmpresaImendesCampo(emp, ["cep", "CEP"])),
      ENDERECO: getEmpresaImendesCampo(emp, ["endereco", "Endereco", "rua"]),
      NUMERO: getEmpresaImendesCampo(emp, ["numero", "Numero"]),
      BAIRRO: getEmpresaImendesCampo(emp, ["bairro", "Bairro"]),
      CIDADE: getEmpresaImendesCampo(emp, ["cidade", "Cidade"]),
      UF: String(getEmpresaImendesCampo(emp, ["uf", "UF"]) || form.UF || "SP")
        .trim()
        .toUpperCase()
        .slice(0, 2),
      CRT: extrairNumeroCrt(emp.CRT ?? emp.crt ?? form.crt),
      USUARIO: getUsuarioGovernancaStorage(),
    };
  };

  const cadastrarEmpresaNaImendes = async (emp = {}) => {
    if (!canGerenciarImendes) {
      showError("Apenas usuários ADM podem cadastrar empresas na IMendes.");
      return;
    }

    let payload;

    try {
      payload = montarPayloadCadastroImendes(emp);
    } catch (error) {
      showError(error.message);
      return;
    }

    const statusAtual = getStatusImendesEmpresa(emp);

    if (statusAtual?.cadastradaNaImendes) {
      showInfo("Esta empresa já está vinculada/cadastrada na IMendes.");
      return;
    }

    const nomeEmpresa =
      payload.NOME_FANTASIA || payload.RAZAO_SOCIAL || `empresa ${payload.ID_EMPRESA}`;

    const confirmar = window.confirm(
      `Vincular ${nomeEmpresa} à IMendes usando o CNPJ ${formatarDocumentoFiscal(payload.CNPJ)}?`,
    );

    if (!confirmar) return;

    try {
      setImendesLoadingEmpresaId(payload.ID_EMPRESA);
      setImendesResultado(null);

      const { data } = await api.post(
        `/ssw/cliente/empresas/${payload.ID_EMPRESA}/imendes/vincular`,
        {
          nrLicenca: payload.NR_LICENCA,
          usuario: getUsuarioGovernancaStorage(),
        },
      );

      await carregarStatusImendesEmpresas(empresasLicenca, payload.NR_LICENCA);

      const statusRetorno = data?.result?.status || data?.status || "";
      const jaCadastrada = statusRetorno === "JA_CADASTRADA";

      setImendesResultado({
        tipo: "success",
        titulo: jaCadastrada ? "Empresa já vinculada" : "Empresa vinculada à IMendes",
        mensagem:
          data?.message ||
          data?.mensagem ||
          (jaCadastrada
            ? "Empresa já estava cadastrada/vinculada na IMendes."
            : "Empresa vinculada à IMendes com sucesso."),
        detalhe: data,
      });

      showInfo(
        data?.message ||
          data?.mensagem ||
          (jaCadastrada
            ? "Empresa já estava vinculada à IMendes."
            : "Empresa vinculada à IMendes."),
      );
    } catch (error) {
      const mensagem = getApiErrorMessage(
        error,
        "Falha ao vincular empresa à IMendes.",
      );

      setImendesResultado({
        tipo: "error",
        titulo: "Falha no vínculo IMendes",
        mensagem,
        detalhe: error?.response?.data || null,
      });

      showError(mensagem);
    } finally {
      setImendesLoadingEmpresaId(null);
    }
  };

  const carregarProgressoSincronizacaoProdutos = async (nrLicenca) => {
    const licenca = String(nrLicenca || form.codigo || "").trim();
    if (!licenca) return null;

    try {
      const { data } = await api.get(
        `/ssw/hub-fiscal-produtos/saneamento/${licenca}/observabilidade`,
        {
          params: { somenteSincronizacao: "S" },
          timeout: 5000,
        },
      );

      const observabilidade = data?.result || data || {};
      const progresso = observabilidade?.sincronizacaoProdutos || null;

      if (progresso) {
        setImendesSincronizacaoProgresso(progresso);
      }

      return progresso;
    } catch {
      return null;
    }
  };
  const habilitarSaneamentoESincronizarProdutos = async () => {
    if (!canGerenciarImendes) {
      showError("Apenas usuários ADM podem habilitar saneamento e sincronizar produtos.");
      return;
    }

    const nrLicenca = String(form.codigo || "").trim();

    if (!nrLicenca) {
      showError("Carregue um cliente/licença antes de continuar.");
      return;
    }

    const resumoInicial = getResumoStatusImendes();

    if (!resumoInicial.temEmpresaImendes) {
      showError(
        "Vincule pelo menos uma empresa na IMendes antes de habilitar o saneamento e sincronizar os produtos.",
      );
      return;
    }

    const empresaPrincipal =
      empresasLicenca.find((emp) => getStatusImendesEmpresa(emp)?.cadastradaNaImendes) ||
      empresasLicenca?.[0] ||
      null;

    const idEmpresaPadrao = getEmpresaImendesId(empresaPrincipal) || 1;
    const usuario = getUsuarioGovernancaStorage();
    let retornoHabilitacao = null;

    const aguardarJobSincronizacao = async () => {
      const inicio = Date.now();
      const timeoutMs = 15 * 60 * 1000;

      while (Date.now() - inicio < timeoutMs) {
        const progresso = await carregarProgressoSincronizacaoProdutos(nrLicenca);
        const status = String(progresso?.status || "").toUpperCase();

        if (["FINALIZADO", "FINALIZADA"].includes(status)) return progresso;

        if (["ERRO", "FALHOU", "CANCELADO"].includes(status)) {
          throw new Error(
            progresso?.erro || progresso?.mensagem || "A sincronização de produtos terminou com erro.",
          );
        }

        await new Promise((resolve) => window.setTimeout(resolve, 1000));
      }

      throw new Error(
        "A sincronização continua no servidor, mas o tempo máximo de acompanhamento desta tela foi atingido.",
      );
    };

    try {
      setImendesResultado(null);

      if (!resumoInicial.saneamentoHabilitado) {
        setImendesHabilitandoLicenca(true);

        const { data } = await api.post(
          `/ssw/cliente/${nrLicenca}/saneamento-fiscal/habilitar`,
          {
            nrLicenca,
            idEmpresa: idEmpresaPadrao,
            usuario,
          },
          { timeout: 30000 },
        );

        retornoHabilitacao = data;
        setImendesHabilitandoLicenca(false);
        await carregarStatusImendesEmpresas(empresasLicenca, nrLicenca);
      }

      setImendesSincronizandoProdutos(true);
      setImendesSincronizacaoProgresso({
        NR_LICENCA: nrLicenca,
        emAndamento: true,
        status: "AGENDANDO",
        fase: "AGENDANDO",
        mensagem: "Agendando sincronização na API exclusiva de saneamento.",
        totalProdutos: 0,
        analisados: 0,
        aGravar: 0,
        gravados: 0,
        inseridos: 0,
        ressincronizados: 0,
        semAlteracao: 0,
        percentual: 0,
      });

      const { data: agendamento } = await api.post(
        `/ssw/hub-fiscal-produtos/saneamento/${nrLicenca}/sincronizar-produtos`,
        {
          ID_EMPRESA: idEmpresaPadrao,
          somenteAtivos: true,
          usuario,
        },
        { timeout: 30000 },
      );

      const jobAgendado = agendamento?.result?.job || agendamento?.result || null;

      if (jobAgendado) {
        setImendesSincronizacaoProgresso((atual) => ({
          ...(atual || {}),
          NR_LICENCA: nrLicenca,
          emAndamento: true,
          status: jobAgendado.DM_STATUS || "AGENDADO",
          fase: jobAgendado.FASE || "AGENDADO",
          mensagem: jobAgendado.DS_MENSAGEM || "Sincronização agendada.",
          idJob: jobAgendado.ID_JOB || null,
        }));
      }

      const progressoFinal = await aguardarJobSincronizacao();
      const totalLidos = Number(progressoFinal?.totalProdutos || progressoFinal?.analisados || 0);
      const inseridos = Number(progressoFinal?.inseridos || 0);
      const ressincronizados = Number(progressoFinal?.ressincronizados || 0);
      const semAlteracao = Number(progressoFinal?.semAlteracao || 0);

      setImendesSincronizacaoProgresso(progressoFinal);
      await carregarStatusImendesEmpresas(empresasLicenca, nrLicenca);

      const mensagemSincronizacao =
        totalLidos > 0
          ? `${totalLidos.toLocaleString("pt-BR")} produto(s) analisado(s): ` +
            `${inseridos.toLocaleString("pt-BR")} novo(s), ` +
            `${ressincronizados.toLocaleString("pt-BR")} reaberto(s) por alteração fiscal e ` +
            `${semAlteracao.toLocaleString("pt-BR")} sem alteração.`
          : "Sincronização concluída sem produtos elegíveis para processar.";

      setImendesResultado({
        tipo: "success",
        titulo: resumoInicial.saneamentoHabilitado
          ? "Produtos sincronizados"
          : "Saneamento habilitado e produtos sincronizados",
        mensagem: mensagemSincronizacao,
        detalhe: {
          habilitacao: retornoHabilitacao,
          agendamento,
          progresso: progressoFinal,
        },
      });

      showInfo(mensagemSincronizacao);
    } catch (error) {
      const mensagem = getApiErrorMessage(
        error,
        "Falha ao habilitar o saneamento ou sincronizar os produtos.",
      );

      const progressoServidor = await carregarProgressoSincronizacaoProdutos(nrLicenca);

      if (progressoServidor?.emAndamento) {
        setImendesResultado({
          tipo: "success",
          titulo: "Sincronização continua no servidor",
          mensagem:
            "A solicitação já foi aceita pela API de saneamento e continua sendo executada em background.",
          detalhe: progressoServidor,
        });
        showInfo("A sincronização continua no servidor. A barra de progresso seguirá atualizando.");
      } else {
        setImendesResultado({
          tipo: "error",
          titulo: "Falha na sincronização dos produtos",
          mensagem,
          detalhe: error?.response?.data || null,
        });
        showError(mensagem);
      }
    } finally {
      setImendesHabilitandoLicenca(false);
      setImendesSincronizandoProdutos(false);
      carregarProgressoSincronizacaoProdutos(nrLicenca);
    }
  };

  const salvarCertificado = async () => {
    if (!form.codigo) return showError("Código do cliente não informado.");
    if (semCertificado)
      return showError("Remova o status 'sem certificado' antes de enviar.");

    const { nomeCertificado, senha, arquivo } = dadosCertificado;
    if (!nomeCertificado || !arquivo)
      return showError("Preencha nome e selecione o arquivo.");
    if (!/\.pfx$/i.test(arquivo.name))
      return showError("Envie um arquivo .pfx.");
    if (!senha?.trim()) return showError("Informe a senha do .pfx.");

    const formData = new FormData();
    formData.append("codigoCliente", String(form.codigo));
    formData.append("nomeCertificado", nomeCertificado);
    formData.append("senha", senha);
    formData.append("arquivo", arquivo);

    try {
      const postResponse = await api.post(`/certificado`, formData);
      const ok =
        postResponse.status >= 200 &&
        postResponse.status < 300 &&
        String(postResponse.data?.mensagem || "")
          .toLowerCase()
          .includes("sucesso");
      if (!ok) return showError("Erro ao salvar certificado.");
      showInfo("Certificado salvo com sucesso.");
      setDadosCertificado({ nomeCertificado: "", senha: "", arquivo: null });
      await carregarCertificados();
    } catch (error) {
      showError(error?.response?.data?.error || "Erro ao salvar certificado.");
    }
  };

  const baixarCertificadoCentralizado = async (cert) => {
    const codigoCliente = String(form.codigo || "").trim();
    if (!codigoCliente) {
      showError("Código do cliente não informado.");
      return;
    }

    try {
      const response = await api.get(
        `/certificado/${encodeURIComponent(codigoCliente)}/download`,
        {
          params: cert?.IdEmpresaPortal
            ? { idEmpresaPortal: cert.IdEmpresaPortal }
            : undefined,
          responseType: "blob",
        },
      );

      const contentDisposition =
        response?.headers?.["content-disposition"] ||
        response?.headers?.["Content-Disposition"] ||
        "";

      let nomeArquivo = "certificado-digital.zip";
      const matchUtf8 = String(contentDisposition).match(
        /filename\*=UTF-8''([^;]+)/i,
      );
      const matchNormal = String(contentDisposition).match(
        /filename="?([^";]+)"?/i,
      );

      if (matchUtf8?.[1]) {
        try {
          nomeArquivo = decodeURIComponent(matchUtf8[1]);
        } catch {
          nomeArquivo = matchUtf8[1];
        }
      } else if (matchNormal?.[1]) {
        nomeArquivo = matchNormal[1].trim();
      }

      const blob = new Blob([response.data], {
        type: response?.headers?.["content-type"] || "application/zip",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = nomeArquivo;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Erro ao baixar certificado centralizado:", error);
      showError(
        error?.response?.data?.error ||
          error?.response?.data?.mensagem ||
          "Erro ao baixar certificado.",
      );
    }
  };

  const certBool = (value) => {
    if (value === true || value === 1) return true;

    const text = String(value ?? "").trim().toLowerCase();

    return ["1", "true", "s", "sim", "yes"].includes(text);
  };

  const certificadoEhSemCertificado = (cert) =>
    String(cert?.NomeCertificado || "").trim().toUpperCase() ===
    "SEM_CERTIFICADO";

  const certificadoEstaVencido = (cert) => {
    if (!cert?.Validade) return false;

    const validade = new Date(cert.Validade);

    if (Number.isNaN(validade.getTime())) return false;

    return validade < new Date();
  };

  const certificadoEhEmissorNfse = (cert) =>
    certBool(cert?.EmissorNfse ?? cert?.emissorNfse);

  const certificadoTemEstruturaEmissao = (cert) =>
    Boolean(cert?.StorageBucket) &&
    Boolean(cert?.StoragePath) &&
    certBool(cert?.TemSenhaCriptografada) &&
    certBool(cert?.TemSenhaIV) &&
    certBool(cert?.TemSenhaTag);

  const podeTornarCertificadoEmissorNfse = (cert) => {
    if (!cadastroAtualEhEmitenteNfse) return false;
    if (!cert?.ID) return false;
    if (certificadoEhSemCertificado(cert)) return false;
    if (certificadoEhEmissorNfse(cert)) return false;
    if (certificadoEstaVencido(cert)) return false;

    return (
      certBool(cert?.PodeTornarEmissorNfse) ||
      certificadoTemEstruturaEmissao(cert)
    );
  };

  const tornarCertificadoEmissorNfse = async (cert) => {
    const idCertificado = Number(cert?.ID);

    if (!cadastroAtualEhEmitenteNfse) {
      showError(
        `Apenas o cadastro ${CODIGO_EMITENTE_NFSE} pode definir certificado emissor NFS-e.`,
      );
      return;
    }

    if (!idCertificado) {
      showError("ID do certificado inválido.");
      return;
    }

    if (certificadoEhSemCertificado(cert)) {
      showError("Registro SEM_CERTIFICADO não pode ser emissor NFS-e.");
      return;
    }

    if (!certificadoTemEstruturaEmissao(cert)) {
      showError(
        "Certificado incompleto para emissão. Reenvie o certificado antes de vincular.",
      );
      return;
    }

    if (certificadoEstaVencido(cert)) {
      showError("Certificado vencido. Envie um certificado válido.");
      return;
    }

    const ok = window.confirm(
      `Definir o certificado ${idCertificado} como emissor NFS-e da SantSystem?`,
    );

    if (!ok) return;

    try {
      setDefinindoCertEmissorId(idCertificado);

      const { data } = await api.put(
        `/certificado/${CODIGO_EMITENTE_NFSE}/${idCertificado}/tornar-emissor-nfse`,
        {
          idEmpresa: ID_EMPRESA_EMITENTE_NFSE,
        },
      );

      showInfo(
        data?.mensagem ||
          "Certificado definido como emissor NFS-e com sucesso.",
      );

      await carregarCertificados();
    } catch (error) {
      console.error("Erro ao definir certificado emissor NFS-e:", error);

      const msg =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.response?.data?.mensagem ||
        "Erro ao definir certificado emissor NFS-e.";

      showError(msg);
    } finally {
      setDefinindoCertEmissorId(null);
    }
  };

  const handleTipoOuLiberacaoChange = (name, value) => {
    let novoForm = { ...form, [name]: value };
    novoForm = aplicarRegrasNegociacaoECancelamento(novoForm, name, value);
    setForm(novoForm);
  };

  useEffect(() => {
    const fetchCertificados = async () => {
      if (!clienteSelecionado?.CodigoCad) {
        setCertificados([]);
        return;
      }
      try {
        const res = await api.get(
          `/certificado/${clienteSelecionado.CodigoCad}`,
        );
        setCertificados(res.data);
      } catch {
        setCertificados([]);
      }
    };
    fetchCertificados();
  }, [clienteSelecionado]);

  useEffect(() => {
    if (
      !clienteSelecionado ||
      !clienteSelecionado.GrupoImp ||
      impostos.length === 0
    )
      return;
    const grupoImpSelecionado = impostos.find(
      (item) => String(item.id) === String(clienteSelecionado.GrupoImp),
    );
    if (grupoImpSelecionado) {
      setForm((prev) => ({ ...prev, imposto: grupoImpSelecionado.id }));
    }
  }, [clienteSelecionado, impostos]);

  const toggleSituacao = (s) =>
    setFiltroBoleto((prev) => ({
      ...prev,
      situacoes: { ...prev.situacoes, [s]: !prev.situacoes[s] },
      page: 1,
    }));

  const setTodasSituacoes = (v) =>
    setFiltroBoleto((prev) => ({
      ...prev,
      situacoes: { Quitado: v, Pendente: v, Cancelado: v },
      page: 1,
    }));


  const buscarCNPJ = async () => {
    const documento = validarCpfCnpjFiscal(form.cnpj);

    setForm((prev) => ({
      ...prev,
      cnpj: formatarDocumentoFiscal(documento.documento || prev.cnpj),
    }));

    if (!documento.documento) return;

    if (!documento.valido) {
      showError(documento.mensagem);
      return;
    }

    if (documento.tipo !== "CNPJ") return;

    setLoadingCnpj(true);
    try {
      const response = await api.get(
        `/cliente/cnpj/${encodeURIComponent(documento.documento)}`,
      );
      const cliente = response?.data;

      if (cliente?.CodigoCad) {
        // garante que o CNPJ não seja apagado se vier vazio da API
        setForm((prev) => {
          const merged = mergeClienteNoForm(cliente, prev);
          // fallback final: se ainda assim ficar vazio, conserva o digitado
          if (!merged.cnpj || !String(merged.cnpj).trim()) {
            merged.cnpj = formatarDocumentoFiscal(documento.documento);
          }
          return merged;
        });

        // opcional: já carregar info do cadastro quando encontrar
        buscarInformacoesCadastro(cliente.CodigoCad);
        setBoletosHabilitados(canVerBoletos);
        setFiltroBoleto((prevF) => ({
          ...prevF,
          nrLicenca: cliente.CodigoCad,
        }));
      }
    } catch (error) {
      console.error("Erro ao buscar CNPJ:", error);
    } finally {
      setLoadingCnpj(false);
    }
  };

  const buscarCEP = async () => {
    const cepLimpo = (form.cep || "").replace(/\D/g, "");
    if (cepLimpo.length !== 8) return;
    setLoadingCep(true);
    try {
      const resp = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      const data = await resp.json();
      if (data.erro) return showError("CEP não encontrado.");
      setForm((prev) => ({
        ...prev,
        rua: data.logradouro || "",
        bairro: data.bairro || "",
        cidade: data.localidade || "",
        UF: data.uf || "",
        codmun: data.ibge || "",
      }));
    } catch (error) {
      showError("Erro ao buscar CEP.");
    } finally {
      setLoadingCep(false);
    }
  };

  const buscarInformacoesCadastro = async (codigo) => {
    try {
      const { data } = await api.get(`/cliente/infoCad`, {
        params: { codigo },
      });
      setInfoCadastro(data);
    } catch (error) {
      console.error("Erro ao buscar informações do cadastro:", error.message);
    }
  };

  const cancelarAgendamentosCliente = async (codigoCliente) => {
    if (!codigoCliente) return;
    try {
      setStatusCancelamento("Cancelando agendamentos pendentes...");
      showInfo("Cancelando agendamentos pendentes...");
      const { data } = await api.get("/agendamentos", {
        params: { chvCad: codigoCliente, status: "pendente" },
      });
      const lista = Array.isArray(data) ? data : [];
      if (!lista.length) {
        showInfo("Nenhum agendamento pendente para este cliente.");
        setStatusCancelamento("Nenhum agendamento pendente para este cliente.");
        return;
      }
      await Promise.all(
        lista.map((ag) =>
          api.delete(`/agendamentos/${ag.id}`).catch((err) => {
            console.error("Erro ao excluir agendamento", err);
            return null;
          }),
        ),
      );
      const msg = `Agendamentos pendentes cancelados: ${lista.length}.`;
      showInfo(msg);
      setStatusCancelamento(msg);
    } catch (error) {
      console.error("Erro ao cancelar agendamentos:", error);
      showError("Erro ao cancelar agendamentos do cliente.");
      setStatusCancelamento("Erro ao cancelar agendamentos do cliente.");
    }
  };

  const enviarArquivosFiscaisCliente = async () => {
    if (!form.codigo) {
      showError("Carregue um cliente antes de enviar os arquivos fiscais.");
      return;
    }

    try {
      setEnviandoFiscal(true);

      const payload = {
        nrLicenca: String(form.codigo),
      };

      if (referenciaFiscal) {
        const partes = referenciaFiscal.split("-");
        const ano = partes[0];
        const mes = partes[1];
        if (ano && mes) {
          payload.referencia = `${ano}-${mes}`; // "YYYY-MM"
        }
      }

      const url = getFiscalExportUrl();

      // CHAMADA FINAL – sem /ssw e sem headers especiais
      const { data } = await axios.post(url, payload);

      const msgApi =
        data?.mensagem ||
        data?.message ||
        "Exportação fiscal disparada. O contador receberá o novo e-mail com o ZIP.";

      showInfo(msgApi);
    } catch (error) {
      console.error("Erro ao enviar arquivos fiscais:", error);

      const msgErro =
        error?.response?.data?.mensagem ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Falha ao disparar a exportação fiscal para este cliente.";

      showError(msgErro);
    } finally {
      setEnviandoFiscal(false);
    }
  };

  const baixarXmlCuponsFiscais = async () => {
    const nrLicenca = String(form.codigo || "").trim();
    const de = String(periodoXmlCupom.de || "").trim();
    const ate = String(periodoXmlCupom.ate || "").trim();

    if (!nrLicenca) {
      showError("Carregue um cliente antes de exportar os XMLs.");
      return;
    }

    if (!de || !ate) {
      showError("Informe a data inicial e a data final da exportação.");
      return;
    }

    if (de > ate) {
      showError("A data inicial não pode ser maior que a data final.");
      return;
    }

    try {
      setExportandoXmlCupom(true);

      // IMPORTANTE:
      // Não usamos axios + responseType=blob nesta exportação.
      // Com blob o navegador aguarda o ZIP inteiro chegar para só então iniciar
      // o download visível. Em produção isso aumenta a espera e o uso de memória.
      //
      // getUri não executa os interceptors do Axios; por isso a rota precisa incluir /ssw explicitamente.
      const urlDownload = api.getUri({
        url: "/ssw/cupom-fiscal-xml/exportar",
        params: {
          nrLicenca,
          de,
          ate,
        },
      });

      const link = document.createElement("a");
      link.href = urlDownload;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      link.remove();

      showInfo(
        "Download iniciado. Acompanhe o progresso pelo gerenciador de downloads do navegador.",
      );
    } catch (error) {
      console.error("Erro ao iniciar exportação dos XMLs de cupons fiscais:", error);
      showError("Falha ao iniciar o download dos XMLs de cupons fiscais.");
    } finally {
      // O download agora é nativo do navegador. Depois de disparado, o React
      // não precisa permanecer aguardando dezenas de MB em memória.
      setTimeout(() => setExportandoXmlCupom(false), 800);
    }
  };

  const cancelarChamadosCliente = async (codigoCliente) => {
    if (!codigoCliente) return;
    try {
      setStatusCancelamento("Cancelando chamados em aberto...");
      showInfo("Cancelando chamados em aberto...");
      const { data } = await api.get(`/chamados/cliente/${codigoCliente}`);
      const lista = Array.isArray(data) ? data : [];
      const abertos = lista.filter(
        (c) => String(c.StatusChamado) !== "1" && !c.DataFim,
      );
      if (!abertos.length) {
        showInfo("Nenhum chamado aberto para este cliente.");
        setStatusCancelamento("Nenhum chamado aberto para este cliente.");
        return;
      }
      const funcionarioAdm =
        sessionStorage.getItem("Usuario") ||
        sessionStorage.getItem("NomeUsuario") ||
        "ADM_WEB";
      const codFuncAdm =
        sessionStorage.getItem("CodFunc") ||
        sessionStorage.getItem("codFunc") ||
        "0";

      await Promise.all(
        abertos.map((c) =>
          api
            .put(`/chamados/intervir/${c.ID}`, {
              funcionarioAdm,
              codFuncAdm,
              nivelAdm: "ADM",
              acao: "FINALIZAR",
              descricaoIntervencao:
                "Finalização automática por cancelamento do cliente.",
            })
            .catch((err) => {
              console.error("Erro ao finalizar chamado", err);
              return null;
            }),
        ),
      );
      const msg = `Chamados em aberto finalizados: ${abertos.length}.`;
      showInfo(msg);
      setStatusCancelamento(msg);
    } catch (error) {
      console.error("Erro ao cancelar chamados:", error);
      showError("Erro ao cancelar chamados do cliente.");
      setStatusCancelamento("Erro ao cancelar chamados do cliente.");
    }
  };

  const carregarBoletosParaCancelamento = async (codigoCliente) => {
    if (!codigoCliente) return;
    try {
      setCancelBoletosLoading(true);
      setStatusCancelamento(
        "Carregando boletos pendentes do cliente para confirmação...",
      );

      const qs = new URLSearchParams();
      qs.set("nrLicenca", String(codigoCliente));
      qs.set("situacoes", "Pendente");
      qs.set("page", "1");
      // use um valor permitido pelo backend – ex: 100
      qs.set("limit", "100");

      const { data } = await api.get(`/boletos?${qs.toString()}`);
      const lista = data?.data || [];

      setCancelBoletosLista(lista);
      setCancelBoletosSelecionados(new Set(lista.map((b) => b.GUID_BOLETO)));
      setCancelBoletosModalOpen(true);

      if (!lista.length) {
        showInfo(
          "Cliente não possui boletos pendentes. Ao confirmar, serão cancelados apenas agendamentos e chamados.",
        );
      } else {
        showInfo(
          "Revise os boletos que serão cancelados e confirme para concluir o cancelamento do cliente.",
        );
      }

      setStatusCancelamento(
        "Revise os boletos pendentes (se houver) e confirme para concluir o cancelamento.",
      );
    } catch (error) {
      console.error("Erro ao carregar boletos p/ cancelamento:", error);
      showError("Erro ao carregar boletos para cancelamento.");
      setStatusCancelamento("Erro ao carregar boletos para cancelamento.");
    } finally {
      setCancelBoletosLoading(false);
    }
  };

  const iniciarFluxoCancelamento = async (codigoCliente) => {
    if (!codigoCliente) return;
    setStatusCancelamento(
      "Iniciando fluxo de cancelamento. Revise os boletos antes de confirmar.",
    );
    // aqui apenas CARREGA boletos e abre o modal de confirmação
    await carregarBoletosParaCancelamento(codigoCliente);
  };

  const toggleBoletoCancelSelecionado = (guid) => {
    setCancelBoletosSelecionados((prev) => {
      const n = new Set(prev);
      if (n.has(guid)) n.delete(guid);
      else n.add(guid);
      return n;
    });
  };

  const confirmarCancelamentoBoletos = async () => {
    const codigoCliente = form.codigo;
    if (!codigoCliente) {
      showError("Código do cliente não encontrado para cancelamento.");
      return;
    }

    const guids = Array.from(cancelBoletosSelecionados);

    try {
      setCancelBoletosModalOpen(false);
      setStatusCancelamento(
        "Executando cancelamento de agendamentos, chamados e boletos...",
      );

      // só aqui efetivamente cancela agendamentos/chamados
      await cancelarAgendamentosCliente(codigoCliente);
      await cancelarChamadosCliente(codigoCliente);

      // e boletos selecionados
      if (guids.length) {
        showInfo("Cancelando boletos selecionados...");
        setStatusCancelamento("Cancelando boletos selecionados...");
        await api.patch(`/boletos/situacao/lote`, {
          situacao: "Cancelado",
          guids,
        });
        showInfo(`Boletos cancelados: ${guids.length}.`);
      } else {
        showInfo(
          "Nenhum boleto selecionado para cancelamento. Eles permanecerão pendentes.",
        );
      }

      const msg = `Fluxo de cancelamento concluído. Boletos cancelados: ${guids.length}.`;
      setStatusCancelamento(msg);

      fetchResumo();
      fetchBoletos();
    } catch (error) {
      console.error("Erro ao executar fluxo de cancelamento:", error);
      showError("Falha ao executar fluxo de cancelamento.");
      setStatusCancelamento("Falha ao executar fluxo de cancelamento.");
    } finally {
      setCancelBoletosLista([]);
      setCancelBoletosSelecionados(new Set());
    }
  };

  const cancelarFluxoCancelamento = () => {
    setCancelBoletosModalOpen(false);
    setCancelBoletosLista([]);
    setCancelBoletosSelecionados(new Set());
    setCancelBoletosLoading(false);
    setStatusCancelamento(
      "Fluxo de cancelamento cancelado pelo usuário. Agendamentos, chamados e boletos não foram alterados.",
    );
    showInfo(
      "Fluxo de cancelamento abortado. Agendamentos, chamados e boletos permanecem inalterados.",
    );
  };

  const gravarOuAtualizar = async () => {
    if (salvando) return;
    const vaiCancelar = isClienteCanceladoForm(form);

    setSalvando(true);

    if (vaiCancelar) {
      setStatusCancelamento(
        "Atualizando cadastro do cliente para cancelamento...",
      );
    } else {
      setStatusCancelamento("");
    }

    const hoje = new Date();
    const dtcad = hoje
      .toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/-/g, "/");

    // se NÃO está cancelando, exige campos obrigatórios
    if (!vaiCancelar) {
      for (let campo of camposObrigatorios) {
        if (!form[campo.nome] || form[campo.nome].toString().trim() === "") {
          showError(`Preencha o campo obrigatório: ${campo.label}`);
          setSalvando(false);
          return;
        }
      }
      if (!form.TipoPdv || form.TipoPdv === "") {
        showError("Selecione o Tipo de PDV");
        setSalvando(false);
        return;
      }
    }

    const documentoFiscal = validarCpfCnpjFiscal(form.cnpj);

    if (!documentoFiscal.valido) {
      showError(documentoFiscal.mensagem);
      setSalvando(false);
      return;
    }

    setForm((prev) => ({
      ...prev,
      cnpj: formatarDocumentoFiscal(documentoFiscal.documento),
    }));

    const payload = {
      TipCad: mapTipoParaDB(form.tipo),
      CpfCnpj: documentoFiscal.documento,
      RazaoSocial: form.razaoSocial,
      NomeFant: form.nomeFantasia,
      Tel1: form.telefone,
      Cel: form.celular,
      Email: form.email,
      EmailContador: form.emailContador,
      Endereco: form.rua,
      Numero: form.numero,
      Bairro: form.bairro,
      Cidade: form.cidade,
      UF: form.UF,
      Crt: form.crt,
      CEP: form.cep.replace(/\D/g, ""),
      Codmun: form.codmun,
      Complemento: form.complemento,
      Obs: form.Obs,
      Restricao: form.restricoes,
      MostraRestricao:
        form.mostrarRestricao === true || form.mostrarRestricao === "true"
          ? "True"
          : "False",
      Desativado: vaiCancelar
        ? "True"
        : form.desativado === true || form.desativado === "true"
          ? "True"
          : "False",
      Comercio: form.comercio,
      DiaVencto: form.vencto,
      GrupoImp: String(form.imposto || ""),
      Boleto_Fisico_Digital:
        form.Boleto_Fisico_Digital === true ||
        form.Boleto_Fisico_Digital === "1"
          ? "1"
          : "0",
      BLQ: vaiCancelar ? "B" : form.liberacao || "",
      Responsavel: form.responsavel,
      NumMaquina: form.NumMaquina || "",
      ServidorWeb:
        form.TipoPdv === "Servidor Web"
          ? "WEB"
          : form.TipoPdv === "Sistema Local"
            ? "LOCAL"
            : form.TipoPdv === "SPW"
              ? "SPW"
              : "",
      RgIe: form.rgIe,
      // NAutoriza é calculado no backend usando CpfCnpj + CodigoCad.
      NFSe_Obrigatoria: form.NFSe_Obrigatoria ? 1 : 0,
      NFSe_Email: String(form.NFSe_Email || "").trim(),
      NFSe_Obs: String(form.NFSe_Obs || "").trim(),
      tempoNegociacao: form.tempoNegociacao || null,
      ...(form.codigo ? {} : { CheckList_Status: "Pendente" }),
    };
    if (!form.codigo) payload.DtCad = dtcad;

    try {
      let response;
      let codigoUsado = form.codigo;

      if (form.codigo) {
        response = await api.put(`/cliente/${form.codigo}`, payload, {
          timeout: 60000,
        });

        showInfo(
          vaiCancelar
            ? "Cadastro atualizado e cliente marcado como desistente."
            : "Cadastro atualizado com sucesso.",
        );
        buscarInformacoesCadastro(form.codigo);
      } else {
        console.log("[CAD] TipCad enviado =", payload.TipCad);

        response = await api.post(`/cliente`, payload, { timeout: 60000 });

        const novoCodigo = response.data?.CodigoCad;

        if (novoCodigo) {
          codigoUsado = novoCodigo;
          try {
            // busca o cliente completo para puxar token, etc.
            const { data: clienteFull } = await api.get(
              `/cliente/${novoCodigo}`,
            );
            setForm((prev) =>
              mergeClienteNoForm(clienteFull, { ...prev, codigo: novoCodigo }),
            );
          } catch (e) {
            console.error("Erro ao buscar cliente recém-criado:", e);
            // fallback: pelo menos garante o código preenchido
            setForm((prev) => ({ ...prev, codigo: novoCodigo }));
          }

          buscarInformacoesCadastro(novoCodigo);
        }

        showInfo(
          vaiCancelar
            ? "Cadastro criado e cliente marcado como desistente."
            : "Cadastro criado com sucesso.",
        );
      }

      if (vaiCancelar && codigoUsado) {
        // depois de salvar como desistente, começa o fluxo guiado (modal)
        await iniciarFluxoCancelamento(codigoUsado);
      }
    } catch (error) {
      console.error("Erro ao salvar cadastro:", error);
      showError("Erro ao salvar cadastro.");
      if (isClienteCanceladoForm(form)) {
        setStatusCancelamento("Erro ao salvar/cancelar cadastro do cliente.");
      }
    } finally {
      setSalvando(false);
    }
  };

  const excluirCadastro = () => setConfirmOpen(true);

  const limparFormulario = () => {
    // voltar para aba principal
    setTabAtiva("cadastro");

    // controle de aviso de restrição (resetar origem)
    mostrarRestricaoOrigRef.current = "false";
    setShowRestricaoModal(false);
    setUltimoCodigoComAviso(null);

    // seleção de cliente / empresas / usuários
    setClienteSelecionado(null);
    setEmpresasLicenca([]);
    setImendesStatusEmpresas({});
    setImendesResultado(null);
    setEmpresaForm({
      id: "",
      nrLicenca: "",
      razaoSocial: "",
      nomeFantasia: "",
      cnpj: "",
      rgIe: "",
      email: "",
      telefone: "",
      cep: "",
      rua: "",
      numero: "",
      bairro: "",
      cidade: "",
      UF: "",
      complemento: "",
    });
    setUsuariosEmpresa([]);

    // info agregada do cadastro (planos / parcelas / recorrência)
    setInfoCadastro({
      planos: [],
      parcelas: [],
      recorrenciaChamados: [],
    });

    // computadores e certificados
    setComputadores([]);
    setCertificados([]);
    setSemCertificado(false);
    setCamposCertificadoDesabilitados(false);
    setDadosCertificado({
      nomeCertificado: "",
      senha: "",
      arquivo: null,
    });
    setMostrarSenha(false);
    setDefinindoCertEmissorId(null);

    // boletos / seleção / fluxo de lote
    resetBoletosTab(); // já zera boletos, resumo, filtro, seleção, etc.
    setBoletosHabilitados(false);
    setCopiedGuid(null);

    // fluxo de cancelamento de cliente + boletos
    setStatusCancelamento("");
    setCancelBoletosModalOpen(false);
    setCancelBoletosLista([]);
    setCancelBoletosSelecionados(new Set());
    setCancelBoletosLoading(false);

    // modal de confirmação de exclusão
    setConfirmOpen(false);

    // form principal
    setForm({
      tipo: "",
      codigo: "",
      dtCad: "",
      dataReativacao: "",
      razaoSocial: "",
      nomeFantasia: "",
      cnpj: "",
      cep: "",
      rua: "",
      bairro: "",
      numero: "",
      cidade: "",
      UF: "",
      pais: "Brasil",
      telefone: "",
      responsavel: "",
      celular: "",
      email: "",
      emailContador: "",
      rgIe: "",
      complemento: "",
      codmun: "",
      Obs: "",
      restricoes: "",
      mostrarRestricao: "false",
      desativado: "false",
      comercio: "",
      vencto: "",
      imposto: "",
      liberacao: "",
      Boleto_Fisico_Digital: "1",
      TipoPdv: "",
      tempoNegociacao: "",
      autorizacao: "",
      tokenLicenca: "",
      NFSe_Obrigatoria: false,
      NFSe_Email: "",
      NFSe_Obs: "",
    });
  };

  const confirmarExclusao = async () => {
    try {
      await api.delete(`/cliente/${form.codigo}`);
      showInfo("Cadastro excluído com sucesso.");
      limparFormulario();
    } catch {
      showError("Erro ao excluir cadastro.");
    } finally {
      setConfirmOpen(false);
    }
  };

  const mapearTipoCadastro = (tipCad) => {
    const mapa = {
      "Cliente Certificado": "Cliente Certificado",
      "Cliente de Hardware": "Cliente de hardware",
      "Cliente de Software": "Cliente de software",
      "Cliente Desistente": "Cliente Desistente",
      "Cliente em Negociação": "Cliente Negociacao",
      "Cliente NF-e": "Cliente NFe",
      Fornecedor: "fornecedor",
      "Outros Cadastros": "outros",
      Representante: "representante",
      Transportadora: "transportadora",
    };
    const chave = tipCad?.trim().toLowerCase();
    for (const [rotulo, valor] of Object.entries(mapa)) {
      if (rotulo.toLowerCase() === chave) return valor;
    }
    return "";
  };

  const mapTipoParaDB = (tipoUI) => {
    const mapa = {
      "Cliente Certificado": "Cliente Certificado",
      "Cliente de hardware": "Cliente de Hardware",
      "Cliente de software": "Cliente de Software",
      "Cliente Desistente": "Cliente Desistente",
      "Cliente Negociacao": "Cliente em Negociação",
      "Cliente NFe": "Cliente NF-e",
      fornecedor: "Fornecedor",
      outros: "Outros Cadastros",
      representante: "Representante",
      transportadora: "Transportadora",
    };
    return mapa[tipoUI] || "";
  };

  // Merge seguro de dados de cliente no form atual.
  // Nunca zera CNPJ se a origem vier vazia/nula.
  const mergeClienteNoForm = (src, prev) => {
    const tipoMapeado = mapearTipoCadastro(src.TipCad) || "Cliente de software";

    const veioTrueDaApi =
      src.MostraRestricao === 1 ||
      src.MostraRestricao === true ||
      String(src.MostraRestricao).toLowerCase() === "true" ||
      String(src.MostraRestricao) === "1";

    // atualiza a ref para este cliente carregado
    mostrarRestricaoOrigRef.current = veioTrueDaApi ? "true" : "false";

    // 🔹 NOVO: tenta achar o token de licença considerando o objeto `licenca` que vem do backend
    const tokenApi =
      src.tokenLicenca ??
      src.TokenLicenca ??
      src.token_licenca ??
      (src.licenca &&
        (src.licenca.TOKEN_LICENCA || src.licenca.token_licenca)) ??
      (src.entrada &&
        src.entrada.licenca &&
        (src.entrada.licenca.TOKEN_LICENCA ||
          src.entrada.licenca.token_licenca)) ??
      prev.tokenLicenca ??
      "";

    return {
      ...prev,
      codigo: src.CodigoCad ?? prev.codigo ?? "",
      dtCad: src.DtCad ?? src.dtCad ?? src.DTCAD ?? prev.dtCad ?? "",
      dataReativacao:
        src.DataReativacao ?? src.dataReativacao ?? prev.dataReativacao ?? "",
      tipo: tipoMapeado,
      razaoSocial: src.RazaoSocial ?? prev.razaoSocial ?? "",
      nomeFantasia: src.NomeFant ?? prev.nomeFantasia ?? "",
      email: src.Email ?? prev.email ?? "",
      emailContador: src.EmailContador ?? prev.emailContador ?? "",
      telefone: src.Tel1 ?? prev.telefone ?? "",
      cep: src.CEP ?? prev.cep ?? "",
      rua: src.Endereco ?? prev.rua ?? "",
      numero: src.Numero ?? prev.numero ?? "",
      bairro: src.Bairro ?? prev.bairro ?? "",
      cidade: src.Cidade ?? prev.cidade ?? "",
      UF: src.UF ?? prev.UF ?? "",
      codmun: src.CodMun ?? prev.codmun ?? "",
      complemento: src.Complemento ?? prev.complemento ?? "",
      celular: src.Cel ?? prev.celular ?? "",
      cnpj:
        src.CpfCnpj && String(src.CpfCnpj).trim()
          ? formatarDocumentoFiscal(src.CpfCnpj)
          : (prev.cnpj ?? ""),
      rgIe: src.RgIe ?? prev.rgIe ?? "",
      comercio: src.Comercio ?? prev.comercio ?? "",
      vencto: src.DiaVencto ?? prev.vencto ?? "",
      imposto: prev.imposto ?? "",
      restricoes: src.Restricao ?? prev.restricoes ?? "",
      Obs: src.Obs ?? prev.Obs ?? "",
      Boleto_Fisico_Digital:
        src.Boleto_Fisico_Digital ?? prev.Boleto_Fisico_Digital ?? "1",
      TipoPdv: ["WEB", "web"].includes(src.ServidorWeb)
        ? "Servidor Web"
        : ["LOCAL", "local"].includes(src.ServidorWeb)
          ? "Sistema Local"
          : src.ServidorWeb === "SPW"
            ? "SPW"
            : (prev.TipoPdv ?? ""),
      responsavel: src.Responsavel ?? prev.responsavel ?? "",
      crt: src.Crt ?? prev.crt ?? "",
      NumMaquina: src.NumMaquina ?? prev.NumMaquina ?? "",
      liberacao: src.BLQ ?? prev.liberacao ?? "",
      mostrarRestricao: veioTrueDaApi ? "true" : "false",
      desativado:
        src.Desativado !== undefined && src.Desativado !== null
          ? String(src.Desativado).toLowerCase() === "true"
            ? "true"
            : String(src.Desativado) === "1"
              ? "true"
              : "false"
          : (prev.desativado ?? "false"),
      pais: "Brasil",
      autorizacao: src.NAutoriza ?? prev.autorizacao ?? "",
      tokenLicenca: tokenApi, // 🔹 agora vem do objeto licenca também
      NFSe_Obrigatoria: getNfseObrigatoria(src),
      NFSe_Email: src.NFSe_Email ?? src.nfseEmail ?? prev.NFSe_Email ?? "",
      NFSe_Obs: src.NFSe_Obs ?? src.nfseObs ?? prev.NFSe_Obs ?? "",
    };
  };

  const mapEmpresaApiToForm = (src) => {
    if (!src) return empresaForm;

    return {
      id: src.id ?? src.ID ?? src.id_empresa ?? src.ID_EMPRESA ?? "",
      nrLicenca: src.nr_licenca ?? src.NR_LICENCA ?? src.nrLicenca ?? "",
      razaoSocial:
        src.razao_social ?? src.RazaoSocial ?? src.RAZAO_SOCIAL ?? "",
      nomeFantasia: src.nome_fantasia ?? src.NomeFant ?? src.NOME_FANT ?? "",
      cnpj: formatarDocumentoFiscal(src.cpf_cnpj ?? src.Cnpj ?? src.CPF_CNPJ ?? ""),
      rgIe: src.rg_ie ?? src.RgIe ?? src.RG_IE ?? "",
      email: src.email ?? src.Email ?? "",
      telefone: src.tel1 ?? src.Tel1 ?? src.Telefone ?? "",
      cep: src.cep ?? src.CEP ?? "",
      rua: src.endereco ?? src.Endereco ?? "",
      numero: src.numero ?? src.Numero ?? "",
      bairro: src.bairro ?? src.Bairro ?? "",
      cidade: src.cidade ?? src.Cidade ?? "",
      UF: src.uf ?? src.UF ?? "",
      complemento: src.complemento ?? src.Complemento ?? "",
    };
  };

  const carregarEmpresasLicenca = async (codigoCad) => {
    if (!codigoCad) {
      setEmpresasLicenca([]);
      return;
    }

    try {
      setLoadingEmpresas(true);

      const { data } = await api.get(`/ssw/cliente/${codigoCad}`);
      const lista = Array.isArray(data?.empresasEntrada)
        ? data.empresasEntrada
        : [];

      setEmpresasLicenca(lista);
      await carregarStatusImendesEmpresas(lista, codigoCad);
    } catch (error) {
      console.error("Erro ao carregar empresas da licença:", error);
      setEmpresasLicenca([]);
      setImendesStatusEmpresas({});
      showError("Erro ao carregar empresas vinculadas à licença.");
    } finally {
      setLoadingEmpresas(false);
    }
  };

  const carregarComputadoresLicenca = useCallback(async (nrLicenca) => {
    const lic = String(nrLicenca || "").trim();
    if (!lic) {
      setComputadores([]);
      return;
    }

    try {
      setLoadingComputadores(true);

      const { data } = await api.get(`/ssw/computador/${lic}`);
      const lista = Array.isArray(data) ? data : data?.data || [];

      setComputadores(lista);
    } catch (e) {
      console.error(e);
      setComputadores([]);
      showError(getApiErrorMessage(e, "Erro ao buscar computadores."));
    } finally {
      setLoadingComputadores(false);
    }
  }, [showError]);

  useEffect(() => {
    if (!form.codigo) {
      setComputadores([]);
      return;
    }
    carregarComputadoresLicenca(form.codigo);
  }, [form.codigo, carregarComputadoresLicenca]);

  const getPcId = (pc) => pc?.ID_COMPUTADOR || pc?.TOKEN_COMPUTADOR || "";

  const resetMaquinaClienteInfo = () => {
    setMaquinaClienteInfo({
      loading: false,
      deleting: false,
      idMaquinaCliente: null,
      erro: "",
      atualizadoEm: null,
    });
  };

  const carregarIdMaquinaCliente = async ({
    nrLicenca,
    idComputador,
    manterDeleting = false,
  }) => {
    const lic = String(nrLicenca || "").trim();
    const idPc = String(idComputador || "").trim();

    if (!lic || !idPc) {
      setMaquinaClienteInfo((prev) => ({
        ...prev,
        loading: false,
        erro: "Licença/Computador inválidos para consultar ID da máquina cliente.",
      }));
      return null;
    }

    setMaquinaClienteInfo((prev) => ({
      ...prev,
      loading: true,
      deleting: manterDeleting ? prev.deleting : false,
      erro: "",
    }));

    try {
      const { data } = await api.get("/ssw/computador-maquina", {
        params: {
          NR_LICENCA: lic,
          ID_COMPUTADOR: idPc,
        },
      });

      const idMaquinaCliente =
        data?.dados?.ID_MAQUINA_CLIENTE ??
        data?.data?.ID_MAQUINA_CLIENTE ??
        data?.ID_MAQUINA_CLIENTE ??
        null;

      setMaquinaClienteInfo((prev) => ({
        ...prev,
        loading: false,
        deleting: manterDeleting ? prev.deleting : false,
        idMaquinaCliente: idMaquinaCliente || null,
        erro: "",
        atualizadoEm: new Date(),
      }));

      return idMaquinaCliente || null;
    } catch (e) {
      console.error("Erro ao consultar ID_MAQUINA_CLIENTE:", e);

      setMaquinaClienteInfo((prev) => ({
        ...prev,
        loading: false,
        deleting: manterDeleting ? prev.deleting : false,
        idMaquinaCliente: null,
        erro: getApiErrorMessage(e, "Falha ao consultar ID_MAQUINA_CLIENTE."),
      }));

      return null;
    }
  };

  const deletarIdMaquinaCliente = async () => {
    const nrLicenca = String(form.codigo || "").trim();
    const idComputador = String(getPcId(pcSelecionado) || "").trim();

    if (!nrLicenca || !idComputador) {
      showError(
        "Licença/Computador inválidos para remover ID da máquina cliente.",
      );
      return;
    }

    const ok = window.confirm(
      "Confirma remover apenas o ID_MAQUINA_CLIENTE deste computador? O cadastro do computador será mantido.",
    );

    if (!ok) return;

    setMaquinaClienteInfo((prev) => ({
      ...prev,
      deleting: true,
      erro: "",
    }));

    try {
      await api.delete("/ssw/computador-maquina", {
        params: {
          NR_LICENCA: nrLicenca,
          ID_COMPUTADOR: idComputador,
        },
      });

      showInfo("ID_MAQUINA_CLIENTE removido com sucesso.");

      await carregarIdMaquinaCliente({
        nrLicenca,
        idComputador,
        manterDeleting: true,
      });

      setMaquinaClienteInfo((prev) => ({
        ...prev,
        deleting: false,
      }));

      await carregarComputadoresLicenca(nrLicenca);
    } catch (e) {
      console.error("Erro ao remover ID_MAQUINA_CLIENTE:", e);

      setMaquinaClienteInfo((prev) => ({
        ...prev,
        deleting: false,
        erro: getApiErrorMessage(e, "Falha ao remover ID_MAQUINA_CLIENTE."),
      }));

      showError(getApiErrorMessage(e, "Falha ao remover ID_MAQUINA_CLIENTE."));
    }
  };

  const abrirEditorParametrosPc = async (pc) => {
    const nrLicenca = String(form.codigo || "").trim();
    const idComputador = String(getPcId(pc) || "").trim();

    if (!nrLicenca || !idComputador) {
      showError("Licença/Computador inválidos para carregar parâmetros.");
      return;
    }

    setPcSelecionado(pc);
    setParamModalOpen(true);
    setParamLoading(true);
    setParamGovernancaLoading(true);
    setParamEdit({});
    setParamList([]);
    setParamGovernancaCatalogo([]);
    setParamGovernancaJustificativa("");
    setParamGovernancaConfirmacao("");
    setParamGovernancaResultado(null);
    resetMaquinaClienteInfo();

    try {
      const [parametrosResult, catalogoResult] = await Promise.allSettled([
        api.get(`/ssw/parametros-computador/${nrLicenca}/${idComputador}`),
        api.get("/ssw/parametros-governanca/catalogo", {
          params: { ativo: "S", limit: 500 },
        }),
        carregarIdMaquinaCliente({ nrLicenca, idComputador }),
      ]);

      if (parametrosResult.status !== "fulfilled") {
        throw parametrosResult.reason;
      }

      const lista = Array.isArray(parametrosResult.value.data)
        ? parametrosResult.value.data
        : parametrosResult.value.data?.data || [];

      const catalogoRaw =
        catalogoResult.status === "fulfilled" ? catalogoResult.value?.data : [];

      const catalogoLista = Array.isArray(catalogoRaw)
        ? catalogoRaw
        : catalogoRaw?.data || catalogoRaw?.rows || [];

      setParamList(lista);
      setParamGovernancaCatalogo(Array.isArray(catalogoLista) ? catalogoLista : []);

      if (catalogoResult.status !== "fulfilled") {
        console.warn(
          "[PARAM-GOV] Não foi possível carregar catálogo de governança.",
          catalogoResult.reason,
        );
        showInfo(
          "Parâmetros carregados, mas o catálogo de governança está indisponível. Parâmetros não identificados como governados serão tratados como legado e exigirão N4 ou superior para alterar o valor.",
        );
      }
    } catch (e) {
      console.error(e);
      showError(
        getApiErrorMessage(e, "Falha ao carregar parâmetros do computador."),
      );
      setParamModalOpen(false);
    } finally {
      setParamLoading(false);
      setParamGovernancaLoading(false);
    }
  };

  const chaveParam = (p) =>
    `${p.NR_LICENCA}||${p.ID_COMPUTADOR}||${p.NM_PARAMETRO}||${p.GRUPO_PARAMETRO || ""}`;

  const onChangeVlParametro = (p, novoValor) => {
    const catalogoGovernanca = encontrarCatalogoGovernanca(p);

    if (!podeAlterarParametro(p, catalogoGovernanca)) {
      const nivelNecessario = catalogoGovernanca
        ? getNivelMutacaoCatalogo(catalogoGovernanca)
        : null;

      showError(
        catalogoGovernanca
          ? `Sem permissão para este parâmetro. Necessário N${nivelNecessario}; seu nível é N${nivelParametroUsuario}.`
          : "Parâmetro legado não governado: alteração direta permitida somente para ADM.",
      );
      return;
    }

    const key = chaveParam(p);
    setParamEdit((prev) => ({ ...prev, [key]: novoValor }));
  };

  const getVlAtual = (p) => {
    const key = chaveParam(p);
    const vEdit = paramEdit[key];
    return vEdit !== undefined ? vEdit : (p.VL_PARAMETRO ?? "");
  };


  const encontrarCatalogoGovernanca = useCallback(
    (parametro = {}) => {
      const nmParametro = normalizarParametroLegado(parametro.NM_PARAMETRO);
      const grupoParametro = String(parametro.GRUPO_PARAMETRO ?? "").trim();

      if (!nmParametro) return null;

      return (
        paramGovernancaCatalogo.find((catalogo) => {
          const legadoCatalogo = normalizarParametroLegado(
            getNumeroParametroLegadoCatalogo(catalogo),
          );
          const grupoCatalogo = getGrupoParametroLegadoCatalogo(catalogo);

          if (!legadoCatalogo || legadoCatalogo !== nmParametro) return false;
          if (grupoCatalogo && grupoCatalogo !== grupoParametro) return false;

          return getCodigoTecnicoCatalogo(catalogo);
        }) || null
      );
    },
    [paramGovernancaCatalogo],
  );

  const podeAlterarParametro = useCallback(
    (parametro = {}, catalogoGovernanca = null) => {
      const catalogo =
        catalogoGovernanca || encontrarCatalogoGovernanca(parametro);

      if (catalogo) {
        return (
          normalizarNivelParametro(nivelParametroUsuario) >=
          getNivelMutacaoCatalogo(catalogo)
        );
      }

      // Parâmetros ainda não catalogados (legado direto):
      // liberados a partir do N4.
      //
      // Importante: o backend aplica a mesma regra para alteração de VL_PARAMETRO.
      // Campos estruturais/técnicos continuam restritos a ADM.
      return normalizarNivelParametro(nivelParametroUsuario) >= 4;
    },
    [encontrarCatalogoGovernanca, nivelParametroUsuario],
  );

  const paramAlteracoes = useMemo(
    () =>
      paramList
        .map((p) => {
          const key = chaveParam(p);
          if (paramEdit[key] === undefined) return null;

          const novo = String(paramEdit[key] ?? "");
          const atual = String(p.VL_PARAMETRO ?? "");

          if (novo === atual) return null;

          const catalogoGovernanca = encontrarCatalogoGovernanca(p);

          return {
            p,
            novo,
            atual,
            catalogoGovernanca,
            governado: Boolean(catalogoGovernanca),
            permitido: podeAlterarParametro(p, catalogoGovernanca),
          };
        })
        .filter(Boolean),
    [
      paramEdit,
      paramList,
      encontrarCatalogoGovernanca,
      podeAlterarParametro,
    ],
  );

  const paramGovernadosAlterados = useMemo(
    () => paramAlteracoes.filter((item) => item.governado),
    [paramAlteracoes],
  );

  const frasesConfirmacaoGovernanca = useMemo(() => {
    const frases = paramGovernadosAlterados
      .filter((item) => parametroExigeConfirmacao(item.catalogoGovernanca))
      .map((item) => getFraseConfirmacaoCatalogo(item.catalogoGovernanca))
      .filter(Boolean);

    return Array.from(new Set(frases));
  }, [paramGovernadosAlterados]);

  const temParametrosGovernadosAlterados = paramGovernadosAlterados.length > 0;
  const fraseConfirmacaoGovernanca = frasesConfirmacaoGovernanca[0] || "";

  const salvarParametrosAlterados = async () => {
    const nrLicenca = String(form.codigo || "").trim();
    const idComputador = String(getPcId(pcSelecionado) || "").trim();

    if (!nrLicenca || !idComputador) {
      showError("Licença/Computador inválidos para salvar parâmetros.");
      return;
    }

    const alterados = paramAlteracoes;

    if (!alterados.length) {
      showInfo("Nenhuma alteração para salvar.");
      setParamModalOpen(false);
      return;
    }

    const semPermissao = alterados.filter((item) => !item.permitido);

    if (semPermissao.length > 0) {
      const primeiro = semPermissao[0];
      const nivelNecessario = primeiro.catalogoGovernanca
        ? getNivelMutacaoCatalogo(primeiro.catalogoGovernanca)
        : null;

      showError(
        primeiro.governado
          ? `Sem permissão para salvar o parâmetro ${primeiro.p.NM_PARAMETRO}. Necessário N${nivelNecessario}; seu nível é N${nivelParametroUsuario}.`
          : `O parâmetro ${primeiro.p.NM_PARAMETRO} é legado e exige N4 ou superior. Seu nível é N${nivelParametroUsuario}.`,
      );
      return;
    }

    const governados = alterados.filter((item) => item.governado);
    const legados = alterados.filter((item) => !item.governado);

    const governadosExigemJustificativa = governados.filter((item) =>
      parametroExigeJustificativa(item.catalogoGovernanca),
    );

    if (
      governadosExigemJustificativa.length > 0 &&
      !String(paramGovernancaJustificativa || "").trim()
    ) {
      showError(
        "Informe a justificativa para alterar parâmetro governado/crítico.",
      );
      return;
    }

    if (frasesConfirmacaoGovernanca.length > 1) {
      showError(
        "Existem parâmetros críticos com frases de confirmação diferentes. Salve um parâmetro governado por vez.",
      );
      return;
    }

    if (
      fraseConfirmacaoGovernanca &&
      String(paramGovernancaConfirmacao || "").trim() !== fraseConfirmacaoGovernanca
    ) {
      showError(`Confirmação inválida. Digite exatamente: ${fraseConfirmacaoGovernanca}`);
      return;
    }

    const ok = window.confirm(
      governados.length
        ? `Confirma salvar ${alterados.length} alteração(ões), sendo ${governados.length} parâmetro(s) governado(s)?\n\nParâmetros governados serão auditados, materializados no legado e enviados para sync.`
        : `Confirma salvar ${alterados.length} alteração(ões) de parâmetro?`,
    );

    if (!ok) return;

    setParamSaving(true);
    setParamGovernancaResultado(null);

    try {
      garantirBearerApi();

      const resultadosGovernanca = [];

      for (const { p, novo, catalogoGovernanca } of governados) {
        const codParametroTecnico = getCodigoTecnicoCatalogo(catalogoGovernanca);

        if (!codParametroTecnico) {
          throw new Error(
            `Parâmetro ${p.NM_PARAMETRO} está governado, mas sem código técnico no catálogo.`,
          );
        }

        await api.post(
          "/ssw/parametros-governanca/alterar",
          {
            codParametroTecnico,
            escopo: "COMPUTADOR",
            nrLicenca,
            idComputador,
            valorNovo: novo,
            justificativa: paramGovernancaJustificativa,
            textoConfirmacao: paramGovernancaConfirmacao,
          },
          { timeout: 120000 },
        );

        const { data: materializacao } = await api.post(
          "/ssw/parametros-governanca/materializar",
          {
            codParametroTecnico,
            escopo: "COMPUTADOR",
            nrLicenca,
            idComputador,
            dryRun: false,
          },
          { timeout: 120000 },
        );

        resultadosGovernanca.push({
          codParametroTecnico,
          nmParametro: p.NM_PARAMETRO,
          valorNovo: novo,
          materializacao,
        });
      }

      await Promise.all(
        legados.map(async ({ p, novo }) => {
          const nm = encodeURIComponent(p.NM_PARAMETRO);
          const grupo = p.GRUPO_PARAMETRO
            ? `?grupo=${encodeURIComponent(p.GRUPO_PARAMETRO)}`
            : "";

          await api.put(
            `/ssw/parametros-computador/${nrLicenca}/${idComputador}/${nm}${grupo}`,
            { vlParametro: novo },
          );
        }),
      );

      setParamGovernancaResultado({
        governados: resultadosGovernanca.length,
        legados: legados.length,
        detalhes: resultadosGovernanca,
      });

      const msgGovernanca = governados.length
        ? ` ${governados.length} via governança.`
        : "";
      const msgLegado = legados.length ? ` ${legados.length} via legado.` : "";

      showInfo(`Parâmetros atualizados com sucesso.${msgGovernanca}${msgLegado}`);

      const { data } = await api.get(
        `/ssw/parametros-computador/${nrLicenca}/${idComputador}`,
      );

      setParamList(Array.isArray(data) ? data : data?.data || []);
      setParamEdit({});
      setParamGovernancaJustificativa("");
      setParamGovernancaConfirmacao("");
      setParamModalOpen(false);
    } catch (e) {
      console.error(e);
      showError(
        getApiErrorMessage(e, "Falha ao salvar parâmetros do computador."),
      );
    } finally {
      setParamSaving(false);
    }
  };

  useEffect(() => {
    api
      .get(`/comercio`)
      .then((res) => {
        const lista = res.data.filter(
          (item) => item.Comercios && item.Comercios.trim() !== "",
        );
        setComercios(lista);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    api
      .get(`/imposto`)
      .then((res) => {
        const listaImpostos = res.data.filter(
          (item) => item.Impostos && item.Impostos.trim() !== "",
        );
        setImpostos(listaImpostos);
      })
      .catch(() => {});
  }, []);

  const headerState = useMemo(() => {
    if (!boletos.length) return false;
    const all = boletos.every((b) => selectedGuids.has(b.GUID_BOLETO));
    if (all) return true;
    const some = boletos.some((b) => selectedGuids.has(b.GUID_BOLETO));
    return some ? "indeterminate" : false;
  }, [boletos, selectedGuids]);

  const paramView = useMemo(() => {
    const q = normalize(paramSearch);

    // 1) FILTRO
    let rows = paramList;
    if (q) {
      rows = rows.filter((p) => {
        const grupo = normalize(p.GRUPO_PARAMETRO);
        const param = normalize(p.NM_PARAMETRO);
        const desc = normalize(p.DS_PARAMETRO);

        if (paramSearchMode === "grupo") return grupo.includes(q);
        if (paramSearchMode === "param") return param.includes(q);

        // all: busca inteligente (grupo + parametro + descrição)
        return grupo.includes(q) || param.includes(q) || desc.includes(q);
      });
    }

    // 2) SORT
    const { key, dir } = paramSort;
    const factor = dir === "asc" ? 1 : -1;

    const getVal = (p) => {
      if (key === "GRUPO_PARAMETRO") return p.GRUPO_PARAMETRO ?? "";
      if (key === "NM_PARAMETRO") return p.NM_PARAMETRO ?? "";
      if (key === "VL_PARAMETRO") return p.VL_PARAMETRO ?? "";
      if (key === "DS_PARAMETRO") return p.DS_PARAMETRO ?? "";
      return "";
    };

    const tryNumber = (v) => {
      const n = Number(String(v).replace(",", "."));
      return Number.isFinite(n) ? n : null;
    };

    return [...rows].sort((a, b) => {
      const av = getVal(a);
      const bv = getVal(b);

      // se for número, ordena como número; senão, string
      const an = tryNumber(av);
      const bn = tryNumber(bv);

      if (an !== null && bn !== null) return (an - bn) * factor;

      return (
        String(av).localeCompare(String(bv), "pt-BR", {
          numeric: true,
          sensitivity: "base",
        }) * factor
      );
    });
  }, [paramList, paramSearch, paramSearchMode, paramSort]);

  useEffect(() => {
    if (headerChkRef.current) {
      headerChkRef.current.indeterminate = headerState === "indeterminate";
      headerChkRef.current.checked = headerState === true;
    }
  }, [headerState]);

  const onRowClick = (guid, evt) => {
    // evita conflito quando clica em controles dentro da linha
    const tag = (evt.target?.tagName || "").toLowerCase();
    if (["input", "button", "select", "a", "svg", "path"].includes(tag)) return;
    setSelectedGuids((prev) => {
      const n = new Set(prev);
      n.has(guid) ? n.delete(guid) : n.add(guid);
      return n;
    });
  };

  return (
    <MainLayout>
      <div className="func-page">
        {/* ===== Toolbar (fora dos cards) ===== */}
        <div className="func-toolbar">
          <div className="left">
            <h1>Cadastro de Cliente</h1>
          </div>
          <div className="right">
            <Button variant="secondary" onClick={limparFormulario}>
              Novo
            </Button>
            <Button onClick={gravarOuAtualizar} disabled={salvando}>
              {salvando
                ? isClienteCanceladoForm(form)
                  ? "Processando cancelamento..."
                  : "Salvando..."
                : form.codigo
                  ? "Atualizar"
                  : "Gravar"}
            </Button>

            {nivelFunc === "ADM" && (
              <Button
                variant="destructive"
                onClick={excluirCadastro}
                disabled={!form.codigo}
              >
                Excluir
              </Button>
            )}
          </div>
        </div>

        {statusCancelamento && isClienteCanceladoForm(form) && (
          <div className="status-cancelamento-banner">{statusCancelamento}</div>
        )}

        {/* ===== Busca (card) ===== */}
        <div className="func-search card">
          <Label>Buscar</Label>
          <SelectCliente
            className="select-cliente"
            value={clienteSelecionado}
            includeInactiveSearch={true}
            onChange={async (cliente) => {
              const reqId = ++selectReqRef.current;

              if (!cliente) {
                setClienteSelecionado(null);
                setEmpresasLicenca([]);
                setInfoCadastro({
                  planos: [],
                  parcelas: [],
                  recorrenciaChamados: [],
                });
                setForm((prev) => ({
                  ...prev,
                  codigo: "",
                  dtCad: "",
                  dataReativacao: "",
                  tokenLicenca: "",
                }));
                resetBoletosTab();
                setBoletosHabilitados(false);
                return;
              }

              try {
                const codigo = prepararEstadoBasicoCliente(cliente);
                if (!codigo) return;

                await hydrateClienteSelecionado(codigo, reqId);
              } catch (e) {
                console.error("Falha ao carregar cliente selecionado:", e);
                showError("Erro ao carregar dados do cliente.");
              }
            }}
          />
        </div>

        {form.codigo && isClienteCanceladoForm(form) && (
          <div className="cliente-inativo-contexto" role="status">
            <div className="cliente-inativo-contexto-copy">
              <span className="cliente-inativo-badge">INATIVO</span>
              <div>
                <strong>Consulta disponível sem reativação</strong>
                <p>
                  Você pode consultar e revisar todos os dados normalmente.
                  Reative o cliente somente quando ele realmente voltar à operação.
                </p>
              </div>
            </div>

            <Button
              variant="secondary"
              onClick={reativarClienteTela}
              disabled={salvando}
            >
              Reativar cliente
            </Button>
          </div>
        )}

        {/* ===== Abas ===== */}
        <Tabs value={tabAtiva} onValueChange={setTabAtiva}>
          <div className="tabs-cadastro" style={{ marginTop: 6 }}>
            <button
              className={`tab-cadastro ${
                tabAtiva === "cadastro" ? "active" : ""
              }`}
              onClick={() => setTabAtiva("cadastro")}
            >
              Cadastro
            </button>
            <button
              className={`tab-cadastro ${tabAtiva === "info" ? "active" : ""}`}
              onClick={() => setTabAtiva("info")}
            >
              Informações do Cadastro
            </button>
            <button
              className={`tab-cadastro ${tabAtiva === "contrato" ? "active" : ""}`}
              onClick={() => setTabAtiva("contrato")}
              disabled={!form.codigo}
              title={!form.codigo ? "Carregue um cliente" : undefined}
            >
              Contrato
            </button>
            <button
              className={`tab-cadastro ${
                tabAtiva === "certificados" ? "active" : ""
              }`}
              onClick={() => setTabAtiva("certificados")}
            >
              Certificados
            </button>
            <button
              className={`tab-cadastro ${
                tabAtiva === "boletos" ? "active" : ""
              }`}
              onClick={() => {
                if (!canVerBoletos)
                  return showError(
                    "Acesso restrito ao setor FINANCEIRO ou ADM.",
                  );
                setTabAtiva("boletos");
              }}
              disabled={!canVerBoletos}
              title={!canVerBoletos ? "Apenas FINANCEIRO/ADM" : undefined}
            >
              Gestão de Boletos
            </button>
            <button
              className={`tab-cadastro ${
                tabAtiva === "computadores" ? "active" : ""
              }`}
              onClick={() => setTabAtiva("computadores")}
              disabled={!form.codigo}
              title={!form.codigo ? "Carregue um cliente" : undefined}
            >
              Computadores
            </button>
          </div>

          {/* ===== ABA: CADASTRO ===== */}
          {tabAtiva === "cadastro" && (
            <TabsContent value="cadastro">
              {/* Identificação */}
              <section className="card section cadastro-identificacao-section">
                <div className="section-title">Identificação</div>

                <div className="grid grid-4">
                  <div>
                    <Label>Tipo de cadastro</Label>
                    <select
                      required
                      className="input native"
                      name="tipo"
                      value={form.tipo}
                      onChange={(e) =>
                        handleTipoOuLiberacaoChange("tipo", e.target.value)
                      }
                    >
                      <option value="">Selecione</option>
                      <option value="Cliente Certificado">
                        Cliente Certificado
                      </option>
                      <option value="Cliente de hardware">
                        Cliente de Hardware
                      </option>
                      <option value="Cliente de software">
                        Cliente de Software
                      </option>
                      <option value="Cliente Desistente">
                        Cliente Desistente
                      </option>
                      <option value="Cliente Negociacao">
                        Cliente em Negociação
                      </option>
                      <option value="Cliente NFe">Cliente NF-e</option>
                      <option value="fornecedor">Fornecedor</option>
                      <option value="outros">Outros Cadastros</option>
                      <option value="representante">Representante</option>
                      <option value="transportadora">Transportadora</option>
                    </select>
                  </div>

                  <div>
                    <Label>Cód. cadastro</Label>
                    <Input
                      name="codigo"
                      value={form.codigo}
                      onChange={handleChange}
                      placeholder="Código"
                      readOnly
                    />
                  </div>

                  <div className="col-span-2 tipo-pdv-card tipo-pdv-card-cadastro">
                    <div className="tipo-pdv-card-header">
                      <Label>Tipo de sistema / PDV</Label>
                      <span
                        className={
                          form.TipoPdv
                            ? "tipo-pdv-status ativo"
                            : "tipo-pdv-status"
                        }
                      >
                        {form.TipoPdv || "Não definido"}
                      </span>
                    </div>

                    <div className="tipo-pdv-options">
                      {TIPOS_PDV.map((t) => (
                        <label
                          key={t}
                          className={`tipo-pdv-option ${
                            form.TipoPdv === t ? "checked" : ""
                          }`}
                        >
                          <input
                            type="radio"
                            name="TipoPdv"
                            value={t}
                            checked={form.TipoPdv === t}
                            onChange={(e) =>
                              setForm((prev) => ({
                                ...prev,
                                TipoPdv: e.target.value,
                              }))
                            }
                          />
                          <span>{t}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="col-span-4">
                    <Label>Razão Social</Label>
                    <Input
                      name="razaoSocial"
                      value={form.razaoSocial}
                      onChange={handleChange}
                      placeholder="Razão Social"
                    />
                  </div>

                  <div className="col-span-4">
                    <Label>Nome Fantasia</Label>
                    <Input
                      name="nomeFantasia"
                      value={form.nomeFantasia}
                      onChange={handleChange}
                      placeholder="Nome Fantasia"
                    />
                  </div>

                  <div>
                    <Label>Responsável</Label>
                    <Input
                      name="responsavel"
                      value={form.responsavel}
                      onChange={handleChange}
                      placeholder="Responsável"
                    />
                  </div>

                  <div>
                    <Label>CRT</Label>
                    <select
                      className="input native"
                      name="crt"
                      value={form.crt}
                      onChange={handleChange}
                    >
                      <option value="">Selecione</option>
                      <option value="1- Simples Nacional">
                        1- Simples Nacional
                      </option>
                      <option value="2- Simples Nacional com sublimite excedido">
                        2- Simples Nacional com sublimite excedido
                      </option>
                      <option value="3- Regime Normal (Regime Periódico de Apuração)">
                        3- Regime Normal (Regime Periódico de Apuração)
                      </option>
                      <option value="4- MEI (Micro empreendedor individual)">
                        4- MEI (Micro empreendedor individual)
                      </option>
                    </select>
                  </div>

                  <div>
                    <Label>Nº de Máquinas</Label>
                    <Input
                      name="NumMaquina"
                      value={form.NumMaquina}
                      onChange={handleChange}
                      placeholder="Número de Máquinas"
                    />
                  </div>

                  <div>
                    <Label>Data de cadastro</Label>
                    <Input
                      name="dtCad"
                      value={formatarDataCadastro(form.dtCad)}
                      placeholder="Data de cadastro"
                      readOnly
                    />
                  </div>

                  <div>
                    <Label>Data de reativação</Label>
                    <Input
                      name="dataReativacao"
                      value={
                        form.dataReativacao
                          ? formatarDataCadastro(form.dataReativacao)
                          : ""
                      }
                      placeholder="Nunca reativado"
                      readOnly
                    />
                  </div>
                </div>
              </section>

              {/* Documentos */}
              <section className="card section" id="documentosCardSection">
                <div className="section-title">Documentos</div>
                <div className="grid grid-2" style={{ alignItems: "end" }}>
                  <div className="rel" id="cnpjInpt">
                    <Label>CPF / CNPJ</Label>
                    <Input
                      name="cnpj"
                      value={form.cnpj}
                      onChange={handleChange}
                      onBlur={buscarCNPJ}
                      placeholder="CPF ou CNPJ alfanumérico"
                      maxLength={18}
                      className="ssw-input with-spinner"
                      style={{ paddingRight: loadingCnpj ? "28px" : undefined }}
                    />
                    <p className="form-hint">
                      CPF numérico com 11 posições ou CNPJ alfanumérico com 14 posições. A busca automática roda apenas para CNPJ.
                    </p>
                    {loadingCnpj && <div className="spinner" />}
                  </div>
                  <div className="rgInpt">
                    <Label>R.G/Inscrição Estadual</Label>
                    <Input
                      id="rgIeInpt"
                      name="rgIe"
                      value={form.rgIe}
                      onChange={handleChange}
                      placeholder="R.G/Inscrição Estadual"
                    />
                  </div>
                </div>
              </section>

              {/* Endereço */}
              <section className="card section">
                <div className="section-title">Endereço</div>
                <div className="grid grid-4">
                  <div className="rel">
                    <Label>CEP</Label>
                    <Input
                      name="cep"
                      value={form.cep}
                      onChange={handleChange}
                      onBlur={buscarCEP}
                      placeholder="00000-000"
                      className="ssw-input with-spinner cep-input"
                    />
                    {loadingCep && <div className="spinner" />}
                  </div>

                  {/* Ordem solicitada: Rua, Nº, Bairro, Cidade, Estado */}
                  <div className="col-span-2">
                    <Label>Rua</Label>
                    <Input
                      name="rua"
                      value={form.rua}
                      onChange={handleChange}
                      placeholder="Rua"
                    />
                  </div>
                  <div>
                    <Label>Nº</Label>
                    <Input
                      name="numero"
                      value={form.numero}
                      onChange={handleChange}
                      placeholder="Número"
                    />
                  </div>

                  <div>
                    <Label>Bairro</Label>
                    <Input
                      name="bairro"
                      value={form.bairro}
                      onChange={handleChange}
                      placeholder="Bairro"
                    />
                  </div>
                  <div className="col-span-2">
                    <Label>Cidade</Label>
                    <Input
                      name="cidade"
                      value={form.cidade}
                      onChange={handleChange}
                      placeholder="Cidade"
                    />
                  </div>
                  <div>
                    <Label>Estado</Label>
                    <select
                      className="input native"
                      name="UF"
                      value={form.UF}
                      onChange={handleChange}
                    >
                      <option value="">Selecione</option>
                      {[
                        "AC",
                        "AL",
                        "AP",
                        "AM",
                        "BA",
                        "CE",
                        "DF",
                        "ES",
                        "GO",
                        "MA",
                        "MT",
                        "MS",
                        "MG",
                        "PA",
                        "PB",
                        "PR",
                        "PE",
                        "PI",
                        "RJ",
                        "RN",
                        "RS",
                        "RO",
                        "RR",
                        "SC",
                        "SP",
                        "SE",
                        "TO",
                      ].map((uf) => (
                        <option key={uf} value={uf}>
                          {uf}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <Label>Cód. Município</Label>
                    <Input
                      name="codmun"
                      value={form.codmun}
                      onChange={handleChange}
                      placeholder="Ex: 3525904"
                    />
                  </div>
                  <div className="col-span-3">
                    <Label>Complemento</Label>
                    <Input
                      name="complemento"
                      value={form.complemento}
                      onChange={handleChange}
                      placeholder="Complemento"
                    />
                  </div>
                </div>
              </section>

              {/* Contato */}
              <section className="card section">
                <div className="section-title">Contato</div>
                <div className="grid grid-3">
                  <div>
                    <Label>Telefone</Label>
                    <Input
                      name="telefone"
                      value={form.telefone}
                      onChange={handleChange}
                      placeholder="(00) 00000-0000"
                    />
                  </div>
                  <div>
                    <Label>Celular</Label>
                    <Input
                      name="celular"
                      value={form.celular}
                      onChange={handleChange}
                      placeholder="(00) 00000-0000"
                    />
                  </div>
                  <div>
                    <Label>E-mail</Label>
                    <Input
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="email@dominio.com"
                    />
                  </div>
                  <div className="col-span-3">
                    <Label>E-mail do contador</Label>
                    <Input
                      name="emailContador"
                      value={form.emailContador}
                      onChange={handleChange}
                      placeholder="contador@empresa.com.br"
                    />
                  </div>
                </div>
              </section>

              {/* Observações / Restrições */}
              <section className="card section">
                <div className="section-title">Observações & Restrições</div>
                <div className="grid grid-2">
                  <div>
                    <Label>Observações</Label>
                    <textarea
                      className="input ssw-textarea"
                      name="Obs"
                      value={form.Obs || ""}
                      onChange={handleChange}
                      placeholder="Observações"
                      rows={8}
                    />
                  </div>
                  <div>
                    <div
                      className="flex items-center"
                      style={{ gap: 8, marginBottom: 6 }}
                    >
                      <SwitchButton
                        checked={
                          form.mostrarRestricao?.toLowerCase() === "true"
                        }
                        onChange={(e) =>
                          setForm((prev) => ({
                            ...prev,
                            mostrarRestricao: e.target.checked
                              ? "true"
                              : "false",
                          }))
                        }
                      />
                      <Label>Mostrar Restrição</Label>
                    </div>
                    <textarea
                      className="input ssw-textarea"
                      name="restricoes"
                      value={form.restricoes || ""}
                      onChange={handleChange}
                      placeholder="Restrições"
                      rows={8}
                    />
                  </div>
                </div>

                <div
                  className="flex items-center"
                  style={{ gap: 8, marginTop: 8 }}
                >
                  <SwitchButton
                    checked={form.desativado === "true"}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setForm((prev) => {
                        let draft = {
                          ...prev,
                          desativado: checked ? "true" : "false",
                        };
                        draft = aplicarRegrasNegociacaoECancelamento(
                          draft,
                          "desativado",
                          draft.desativado,
                        );
                        return draft;
                      });
                    }}
                  />
                  <Label>Desativado</Label>
                </div>
              </section>
            </TabsContent>
          )}

          {/* ===== ABA: INFORMAÇÕES DO CADASTRO ===== */}
          {tabAtiva === "info" && (
            <TabsContent value="info">
              <section className="card section">
                <div className="section-title">Informações do Cadastro</div>

                <div className="grid grid-4">
                  <div>
                    <Label>Nº Autorização</Label>
                    <Input
                      name="autorizacao"
                      value={form.autorizacao}
                      onChange={handleChange}
                      placeholder="Nº Autorização"
                      readOnly
                    />
                  </div>
                  <div>
                    <Label htmlFor="comercio">Tipo de Comércio</Label>
                    <select
                      id="comercio"
                      name="comercio"
                      className="input native"
                      value={form.comercio || ""}
                      onChange={(e) =>
                        setForm((prev) => ({
                          ...prev,
                          comercio: e.target.value,
                        }))
                      }
                    >
                      <option value="">Selecione...</option>
                      {comercios.map((item) => (
                        <option key={item.ID} value={item.Comercios}>
                          {item.Comercios}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <Label>Dia de Vencimento</Label>
                    <select
                      className="input native"
                      name="vencto"
                      value={form.vencto}
                      onChange={handleChange}
                    >
                      <option value="">Selecione...</option>
                      <option value="1">01</option>
                      <option value="15">15</option>
                    </select>
                  </div>
                  <div>
                    <Label htmlFor="imposto">Grupo de Imposto</Label>
                    <select
                      id="imposto"
                      name="imposto"
                      className="input native"
                      value={form.imposto || ""}
                      onChange={(e) =>
                        setForm((prev) => ({
                          ...prev,
                          imposto: e.target.value,
                        }))
                      }
                    >
                      <option value="">Selecione...</option>
                      {impostos.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.Impostos}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-span-4">
                    <Label>Token da Licença</Label>
                    <Input
                      name="tokenLicenca"
                      value={form.tokenLicenca || ""}
                      onChange={handleChange}
                      placeholder="Token gerado para a licença"
                      readOnly
                    />
                  </div>
                </div>

                <div className="nfse-config-card">
                  <div className="nfse-config-header">
                    <div>
                      <span className="nfse-eyebrow">Configuração fiscal</span>
                      <h3>NFS-e / emissão obrigatória</h3>
                      <p>
                        Controle operacional para clientes que precisam entrar
                        obrigatoriamente na pré-emissão mensal de NFS-e.
                      </p>
                    </div>

                    <span
                      className={`nfse-status-pill ${
                        form.NFSe_Obrigatoria ? "ativo" : "inativo"
                      }`}
                    >
                      {form.NFSe_Obrigatoria
                        ? "Obrigatória"
                        : "Não obrigatória"}
                    </span>
                  </div>

                  <div className="nfse-grid">
                    <div className="nfse-switch-card">
                      <div>
                        <strong>Emissão de NFS-e obrigatória</strong>
                        <small>
                          Quando ativo, o cliente entra na pré-emissão mesmo fora
                          do range de valor.
                        </small>
                      </div>

                      <SwitchButton
                        checked={!!form.NFSe_Obrigatoria}
                        onChange={(e) =>
                          setForm((prev) => ({
                            ...prev,
                            NFSe_Obrigatoria: !!e.target.checked,
                          }))
                        }
                      />
                    </div>

                    <div className="nfse-email-field">
                      <Label>E-mail para envio da NFS-e</Label>
                      <Input
                        name="NFSe_Email"
                        value={form.NFSe_Email || ""}
                        onChange={handleChange}
                        placeholder="financeiro@cliente.com.br"
                      />
                      <p className="form-hint">
                        Se vazio, será usado o e-mail principal do cadastro.
                      </p>
                    </div>

                    <div className="nfse-obs-field">
                      <Label>Observação NFS-e</Label>
                      <textarea
                        className="input ssw-textarea"
                        name="NFSe_Obs"
                        value={form.NFSe_Obs || ""}
                        onChange={handleChange}
                        placeholder="Ex: cliente com emissão obrigatória mensal, enviar cópia para financeiro..."
                        rows={4}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="fiscal-export-toolbar"
                  style={{
                    marginTop: 16,
                    display: "flex",
                    gap: 12,
                    alignItems: "flex-end",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ minWidth: 220 }}>
                    <Label>Referência fiscal</Label>
                    <Input
                      type="month"
                      value={referenciaFiscal}
                      onChange={(e) => setReferenciaFiscal(e.target.value)}
                      disabled={!form.codigo || enviandoFiscal}
                    />
                    <p className="form-hint">
                      Deixe em branco para enviar o mês anterior completo.
                    </p>
                  </div>

                  <div>
                    <Label>&nbsp;</Label>
                    <Button
                      type="button"
                      onClick={enviarArquivosFiscaisCliente}
                      disabled={!form.codigo || enviandoFiscal}
                    >
                      {enviandoFiscal
                        ? "Enviando arquivos fiscais..."
                        : "Enviar arquivos fiscais"}
                    </Button>
                  </div>
                </div>

                <div className="cupom-xml-export-card">
                  <div className="cupom-xml-export-header">
                    <div>
                      <span className="cupom-xml-export-eyebrow">
                        Exportação NFC-e
                      </span>
                      <h3>Baixar XML dos cupons fiscais</h3>
                      <p>
                        Gere um ZIP com um arquivo XML para cada cupom da licença,
                        considerando o período de inclusão informado.
                      </p>
                    </div>

                    <span className="cupom-xml-export-badge">ZIP</span>
                  </div>

                  <div className="cupom-xml-export-grid">
                    <div className="cupom-xml-export-field">
                      <Label>Data inicial</Label>
                      <Input
                        type="date"
                        value={periodoXmlCupom.de}
                        onChange={(e) =>
                          setPeriodoXmlCupom((prev) => ({
                            ...prev,
                            de: e.target.value,
                          }))
                        }
                        disabled={!form.codigo || exportandoXmlCupom}
                      />
                    </div>

                    <div className="cupom-xml-export-field">
                      <Label>Data final</Label>
                      <Input
                        type="date"
                        value={periodoXmlCupom.ate}
                        onChange={(e) =>
                          setPeriodoXmlCupom((prev) => ({
                            ...prev,
                            ate: e.target.value,
                          }))
                        }
                        disabled={!form.codigo || exportandoXmlCupom}
                      />
                    </div>

                    <div className="cupom-xml-export-action">
                      <Label>&nbsp;</Label>
                      <Button
                        type="button"
                        onClick={baixarXmlCuponsFiscais}
                        disabled={
                          !form.codigo ||
                          !periodoXmlCupom.de ||
                          !periodoXmlCupom.ate ||
                          exportandoXmlCupom
                        }
                      >
                        <FiDownload style={{ marginRight: 7 }} />
                        {exportandoXmlCupom
                          ? "Gerando e baixando ZIP..."
                          : "Baixar ZIP de XMLs"}
                      </Button>
                    </div>
                  </div>

                  <div className="cupom-xml-export-help">
                    A data final é inclusiva. O download usa a licença carregada no
                    cadastro: <strong>{form.codigo || "—"}</strong>. Para períodos com
                    muitos cupons, mantenha a tela aberta até o navegador concluir o ZIP.
                  </div>
                </div>

                {/* ===== Empresas vinculadas à licença ===== */}
                <div style={{ marginTop: 18 }}>
                  <div className="section-subtitle">
                    Empresas vinculadas a esta licença
                  </div>

                  <div
                    style={{
                      marginTop: 12,
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      variant="secondary"
                      onClick={handleIncluirEmpresa}
                      disabled={!form.codigo}
                    >
                      Incluir Empresa
                    </Button>
                  </div>

                  {loadingEmpresas ? (
                    <p>Carregando empresas...</p>
                  ) : !empresasLicenca.length ? (
                    <p>Nenhuma empresa vinculada a esta licença.</p>
                  ) : (
                    <div style={{ overflowX: "auto", marginTop: 8 }}>
                      <table className="table-sm" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Razão Social</th>
                            <th>Nome Fantasia</th>
                            <th>CNPJ</th>
                            <th>Cidade/UF</th>
                            <th>E-mail</th>
                            <th style={{ width: 190, textAlign: "center" }}>
                              IMendes
                            </th>
                            <th style={{ width: 260, textAlign: "center" }}>
                              Ações
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {empresasLicenca.map((emp) => (
                            <tr key={emp.id}>
                              <td>{emp.id}</td>
                              <td>{emp.razao_social}</td>
                              <td>{emp.nome_fantasia}</td>
                              <td>{emp.cpf_cnpj}</td>
                              <td>
                                {emp.cidade} / {emp.uf}
                              </td>
                              <td>{emp.email}</td>
                              <td style={{ textAlign: "center" }}>
                                {(() => {
                                  const status = getStatusImendesEmpresa(emp);

                                  if (imendesStatusLoading && !status) {
                                    return <span className="imendes-status-chip loading">Consultando...</span>;
                                  }

                                  if (status?.erro) {
                                    return <span className="imendes-status-chip error">Erro status</span>;
                                  }

                                  if (status?.cadastradaNaImendes) {
                                    return <span className="imendes-status-chip success">Já vinculada</span>;
                                  }

                                  return <span className="imendes-status-chip pending">Pendente</span>;
                                })()}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                <div className="empresa-acoes-inline">
                                  <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={() => handleGerenciarEmpresa(emp)}
                                  >
                                    Gerenciar
                                  </Button>

                                  {canGerenciarImendes && (
                                    <Button
                                      variant="secondary"
                                      size="sm"
                                      type="button"
                                      onClick={() => cadastrarEmpresaNaImendes(emp)}
                                      disabled={
                                        imendesLoadingEmpresaId === getEmpresaImendesId(emp) ||
                                        imendesStatusLoading ||
                                        getStatusImendesEmpresa(emp)?.cadastradaNaImendes
                                      }
                                      title={
                                        getStatusImendesEmpresa(emp)?.cadastradaNaImendes
                                          ? "Empresa já vinculada/cadastrada na IMendes"
                                          : "Vincular cadastro desta empresa à IMendes"
                                      }
                                    >
                                      {imendesLoadingEmpresaId === getEmpresaImendesId(emp)
                                        ? "Vinculando..."
                                        : getStatusImendesEmpresa(emp)?.cadastradaNaImendes
                                          ? "Já vinculada"
                                          : "Vincular IMendes"}
                                    </Button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <p style={{ marginTop: 4, fontSize: 12 }}>
                        Clique em uma linha para editar os dados completos da
                        empresa.
                      </p>
                    </div>
                  )}
                </div>


                <div className="imendes-admin-card">
                  <div className="imendes-admin-header">
                    <div>
                      <span className="imendes-eyebrow">IMendes / Saneamento fiscal</span>
                      <h3>Cadastro da empresa do cliente na IMendes</h3>
                      <p>
                        Use este painel para enviar o cadastro da empresa do cliente para a IMendes
                        e habilitar o saneamento fiscal somente para licenças autorizadas.
                      </p>
                    </div>

                    <span
                      className={`imendes-access-badge ${
                        canGerenciarImendes ? "enabled" : "locked"
                      }`}
                    >
                      {canGerenciarImendes ? "ADM liberado" : "Apenas ADM"}
                    </span>
                  </div>

                  {!form.codigo ? (
                    <div className="imendes-admin-alert muted">
                      Carregue um cliente/licença para liberar as ações da IMendes.
                    </div>
                  ) : !canGerenciarImendes ? (
                    <div className="imendes-admin-alert warning">
                      Esta área é restrita para usuários ADM. O usuário atual pode visualizar,
                      mas não pode cadastrar empresas na IMendes nem habilitar saneamento.
                    </div>
                  ) : (
                    <>
                      {(() => {
                        const resumo = getResumoStatusImendes();

                        return (
                          <>
                            <div className="imendes-status-grid">
                              <div className="imendes-status-card">
                                <span>Empresas</span>
                                <strong>{resumo.totalEmpresas}</strong>
                              </div>
                              <div className="imendes-status-card">
                                <span>Vínculo IMendes</span>
                                <strong className={resumo.temEmpresaImendes ? "ok" : "warn"}>
                                  {resumo.temEmpresaImendes ? "Existe" : "Pendente"}
                                </strong>
                              </div>
                              <div className="imendes-status-card">
                                <span>Saneamento</span>
                                <strong className={resumo.saneamentoHabilitado ? "ok" : "warn"}>
                                  {resumo.saneamentoHabilitado ? "Habilitado" : "Não habilitado"}
                                </strong>
                              </div>
                            </div>

                            <div className="imendes-admin-actions">
                              <Button
                                type="button"
                                variant="outline"
                                onClick={() => carregarStatusImendesEmpresas(empresasLicenca, form.codigo)}
                                disabled={!form.codigo || imendesStatusLoading}
                              >
                                {imendesStatusLoading ? "Consultando status..." : "Atualizar status"}
                              </Button>

                              <Button
                                type="button"
                                variant="secondary"
                                onClick={habilitarSaneamentoESincronizarProdutos}
                                disabled={
                                  !form.codigo ||
                                  imendesHabilitandoLicenca ||
                                  imendesSincronizandoProdutos ||
                                  imendesStatusLoading ||
                                  !resumo.temEmpresaImendes
                                }
                                title={
                                  !resumo.temEmpresaImendes
                                    ? "Vincule uma empresa na IMendes antes de continuar"
                                    : resumo.saneamentoHabilitado
                                      ? "Sincronizar os produtos da licença com a esteira de saneamento"
                                      : "Habilitar saneamento fiscal e depois sincronizar os produtos da licença"
                                }
                              >
                                {imendesHabilitandoLicenca
                                  ? "Habilitando saneamento..."
                                  : imendesSincronizandoProdutos
                                    ? "Sincronizando produtos..."
                                    : resumo.saneamentoHabilitado
                                      ? "Sincronizar produtos"
                                      : "Habilitar saneamento e sincronizar produtos"}
                              </Button>
                            </div>

                            {imendesSincronizacaoProgresso ? (
                              <div
                                style={{
                                  marginTop: 12,
                                  padding: 12,
                                  border: "1px solid #dbeafe",
                                  borderRadius: 12,
                                  background: "#f8fbff",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 12,
                                    marginBottom: 8,
                                  }}
                                >
                                  <div>
                                    <strong style={{ display: "block", color: "#0f172a" }}>
                                      Sincronização dos produtos
                                    </strong>
                                    <small style={{ color: "#64748b" }}>
                                      {imendesSincronizacaoProgresso?.mensagem ||
                                        "Aguardando informações da sincronização."}
                                    </small>
                                  </div>

                                  <strong style={{ color: "#1d4ed8" }}>
                                    {Math.max(
                                      0,
                                      Math.min(
                                        100,
                                        Number(imendesSincronizacaoProgresso?.percentual || 0),
                                      ),
                                    ).toLocaleString("pt-BR", {
                                      maximumFractionDigits: 2,
                                    })}
                                    %
                                  </strong>
                                </div>

                                <div
                                  style={{
                                    width: "100%",
                                    height: 10,
                                    overflow: "hidden",
                                    borderRadius: 999,
                                    background: "#e2e8f0",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: `${Math.max(
                                        0,
                                        Math.min(
                                          100,
                                          Number(imendesSincronizacaoProgresso?.percentual || 0),
                                        ),
                                      )}%`,
                                      height: "100%",
                                      borderRadius: 999,
                                      background: "#2563eb",
                                      transition: "width 250ms ease",
                                    }}
                                  />
                                </div>

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
                                    gap: 8,
                                    marginTop: 10,
                                  }}
                                >
                                  <div>
                                    <small style={{ color: "#64748b" }}>Fase</small>
                                    <strong style={{ display: "block" }}>
                                      {imendesSincronizacaoProgresso?.fase || "-"}
                                    </strong>
                                  </div>
                                  <div>
                                    <small style={{ color: "#64748b" }}>Total ERP</small>
                                    <strong style={{ display: "block" }}>
                                      {Number(
                                        imendesSincronizacaoProgresso?.totalProdutos || 0,
                                      ).toLocaleString("pt-BR")}
                                    </strong>
                                  </div>
                                  <div>
                                    <small style={{ color: "#64748b" }}>Analisados</small>
                                    <strong style={{ display: "block" }}>
                                      {Number(
                                        imendesSincronizacaoProgresso?.analisados || 0,
                                      ).toLocaleString("pt-BR")}
                                    </strong>
                                  </div>
                                  <div>
                                    <small style={{ color: "#64748b" }}>Novos</small>
                                    <strong style={{ display: "block" }}>
                                      {Number(
                                        imendesSincronizacaoProgresso?.inseridos || 0,
                                      ).toLocaleString("pt-BR")}
                                    </strong>
                                  </div>
                                  <div>
                                    <small style={{ color: "#64748b" }}>Alterados</small>
                                    <strong style={{ display: "block" }}>
                                      {Number(
                                        imendesSincronizacaoProgresso?.ressincronizados || 0,
                                      ).toLocaleString("pt-BR")}
                                    </strong>
                                  </div>
                                  <div>
                                    <small style={{ color: "#64748b" }}>Sem alteração</small>
                                    <strong style={{ display: "block" }}>
                                      {Number(
                                        imendesSincronizacaoProgresso?.semAlteracao || 0,
                                      ).toLocaleString("pt-BR")}
                                    </strong>
                                  </div>
                                  <div>
                                    <small style={{ color: "#64748b" }}>Gravados</small>
                                    <strong style={{ display: "block" }}>
                                      {Number(
                                        imendesSincronizacaoProgresso?.gravados || 0,
                                      ).toLocaleString("pt-BR")}
                                    </strong>
                                  </div>
                                </div>
                              </div>
                            ) : null}

                            <div className="imendes-admin-help">
                              <strong>Como usar:</strong> primeiro confira se a empresa está vinculada
                              à licença e com CNPJ/UF corretos. Depois clique em <b>Vincular IMendes</b>
                              na linha da empresa. Com ao menos uma empresa vinculada, use o botão ao
                              lado para habilitar o saneamento e, na sequência, sincronizar os produtos
                              da licença com a esteira. Se o saneamento já estiver habilitado, o mesmo
                              botão executa somente a sincronização dos produtos.
                            </div>
                          </>
                        );
                      })()}
                    </>
                  )}

                  {imendesResultado && (
                    <div className={`imendes-result ${imendesResultado.tipo}`}>
                      <strong>{imendesResultado.titulo}</strong>
                      <span>{imendesResultado.mensagem}</span>
                    </div>
                  )}
                </div>

                <Accordion type="multiple" className="w-full">
                  <AccordionItem value="infoGeral">
                    <AccordionTrigger>Informações Gerais</AccordionTrigger>
                    <AccordionContent>
                      <div className="grid grid-2">
                        <div
                          className="flex items-center"
                          id="switchBtBoleto"
                          style={{ gap: 8 }}
                        >
                          <SwitchButton
                            checked={form.Boleto_Fisico_Digital === "1"}
                            onChange={(e) =>
                              setForm((prev) => ({
                                ...prev,
                                Boleto_Fisico_Digital: e.target.checked
                                  ? "1"
                                  : "0",
                              }))
                            }
                          />
                          <Label>
                            {form.Boleto_Fisico_Digital === "1"
                              ? "Boleto Digital"
                              : "Boleto Físico"}
                          </Label>
                        </div>

                        <div>
                          <Label>Liberação</Label>
                          <select
                            className="input native"
                            name="liberacao"
                            value={form.liberacao}
                            onChange={(e) =>
                              handleTipoOuLiberacaoChange(
                                "liberacao",
                                e.target.value,
                              )
                            }
                          >
                            <option value="">Selecione...</option>
                            <option value="B">Bloqueado</option>
                            <option value="L">Liberado</option>
                            <option value="G">Negociação</option>
                            <option value="N">Normal</option>
                            <option value="P">Piloto</option>
                          </select>
                        </div>
                      </div>
                    </AccordionContent>
                  </AccordionItem>

                  {/* Planos */}
                  <AccordionItem value="planos">
                    <AccordionTrigger>Planos Ativos</AccordionTrigger>
                    <AccordionContent>
                      <div className="tabela-planos">
                        <div className="acoes-planos">
                          <div className="btns-planos">
                            <Button
                              size="sm"
                              className="btPlanos"
                              onClick={() => setShowModalPlanos(true)}
                            >
                              +
                            </Button>
                          </div>
                        </div>

                        <table>
                          <thead>
                            <tr>
                              <th>Plano</th>
                              <th>Vl. Cobrado</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {infoCadastro.planos.map((plano) => (
                              <tr key={plano.ID}>
                                <td>{plano.Plano}</td>
                                <td>
                                  {modoEdicaoPlanoId === plano.ID ? (
                                    <Input
                                      value={valorEdicao}
                                      onChange={(e) => {
                                        const valor = e.target.value
                                          .replace(/[^\d,]/g, "")
                                          .replace(
                                            /^(\d{0,6})(,\d{0,2}).*/,
                                            "$1$2",
                                          );
                                        setValorEdicao(valor);
                                      }}
                                      className="w-24"
                                      placeholder="0,00"
                                    />
                                  ) : (
                                    <>R$ {formatarValorMonetario(plano.ValorCobrado) || "0,00"}</>
                                  )}
                                </td>
                                <td>
                                  <div className="flex" style={{ gap: 6 }}>
                                    {modoEdicaoPlanoId === plano.ID ? (
                                      <>
                                        <Button
                                          size="sm"
                                          variant="ghost"
                                          title="Salvar"
                                          onClick={() =>
                                            handleSalvarEdicaoPlano(plano.ID)
                                          }
                                        >
                                          💾
                                        </Button>
                                        <Button
                                          size="sm"
                                          variant="ghost"
                                          title="Cancelar"
                                          onClick={() =>
                                            setModoEdicaoPlanoId(null)
                                          }
                                        >
                                          ❌
                                        </Button>
                                      </>
                                    ) : (
                                      <>
                                        <Button
                                          size="sm"
                                          variant="ghost"
                                          title="Editar"
                                          onClick={() => {
                                            setModoEdicaoPlanoId(plano.ID);
                                            setValorEdicao(
                                              formatarValorMonetario(plano.ValorCobrado),
                                            );
                                          }}
                                        >
                                          <FiEdit />
                                        </Button>
                                        <Button
                                          size="sm"
                                          variant="ghost"
                                          title="Excluir"
                                          onClick={() => {
                                            setPlanoSelecionado(plano);
                                            setShowConfirmExcluirPlano(true);
                                          }}
                                        >
                                          <FiTrash className="text-red-600" />
                                        </Button>
                                      </>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {showConfirmExcluirPlano && planoSelecionado && (
                        <ConfirmDialog
                          open={showConfirmExcluirPlano}
                          titulo="Confirmar Exclusão"
                          mensagem={`Deseja realmente excluir o plano "${planoSelecionado.Plano}"?`}
                          onConfirm={async () => {
                            try {
                              await api.delete(
                                `/ClientesPlanos/plano/${planoSelecionado.ID}`,
                              );
                              showInfo("Plano excluído com sucesso.");
                              atualizarDadosCliente();
                            } catch {
                              showError("Erro ao excluir plano.");
                            } finally {
                              setShowConfirmExcluirPlano(false);
                              setPlanoSelecionado(null);
                            }
                          }}
                          onClose={() => {
                            setShowConfirmExcluirPlano(false);
                            setPlanoSelecionado(null);
                          }}
                        />
                      )}
                    </AccordionContent>
                  </AccordionItem>

                  <AccordionItem value="accordionParcelas">
                    <AccordionTrigger>Últimas 5 Parcelas</AccordionTrigger>
                    <AccordionContent>
                      <div className="tabela-parcelas">
                        <table>
                          <thead>
                            <tr>
                              <th>Data</th>
                              <th>Valor</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {infoCadastro.parcelas.map((parcela, index) => (
                              <tr
                                key={index}
                                className={
                                  parcela.Situacao === "Quitado"
                                    ? "pago"
                                    : "pendente"
                                }
                              >
                                <td>{parcela.Data}</td>
                                <td>R$ {parcela.Valor}</td>
                                <td>{parcela.Situacao}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </AccordionContent>
                  </AccordionItem>

                  <AccordionItem value="RecorrenciaChamados">
                    <AccordionTrigger>Recorrência de Chamados</AccordionTrigger>
                    <AccordionContent>
                      <div className="grafico-chamados mt-4">
                        <ChamadosChart
                          data={infoCadastro.recorrenciaChamados}
                        />
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </section>
            </TabsContent>
          )}

          {/* ===== ABA: CONTRATO ===== */}
          {tabAtiva === "contrato" && (
            <TabsContent value="contrato">
              <ContratoClientePanel codigoCad={form.codigo} />
            </TabsContent>
          )}

          {/* ===== ABA: CERTIFICADOS ===== */}
          {tabAtiva === "certificados" && (
            <TabsContent value="certificados">
              <section className="card section certificados-section">
                <div className="certificados-topbar">
                  <div>
                    <div className="section-title">
                      Upload de Certificado Digital
                    </div>
                    <p className="section-subtitle">
                      Envie o certificado A1 do cliente. Os certificados
                      cadastrados ficam disponíveis logo abaixo.
                    </p>
                  </div>

                  <div className="certificados-sem-certificado">
                    <div>
                      <strong>Cliente sem certificado</strong>
                      <span>Bloqueia o cadastro enquanto estiver marcado.</span>
                    </div>

                    <SwitchButton
                      checked={semCertificado}
                      disabled={loadingSwitch || !form.codigo}
                      onChange={async (e) => {
                        const checked = e.target.checked;
                        setSemCertificado(checked);
                        if (!form.codigo) return;

                        try {
                          setLoadingSwitch(true);

                          if (checked) {
                            const response = await api.post("/certificado", {
                              codigoCliente: form.codigo,
                              nomeCertificado: "SEM_CERTIFICADO",
                              senha: "",
                              arquivo: null,
                            });

                            if (
                              response.status >= 200 &&
                              response.status < 300
                            ) {
                              showInfo(
                                "Cliente marcado como sem certificado.",
                              );
                              setCamposCertificadoDesabilitados(true);
                              carregarCertificados();
                            } else {
                              showError(
                                "Erro ao marcar cliente como sem certificado.",
                              );
                            }
                          } else {
                            const response = await api.delete(
                              `/certificado/sem-certificado/${form.codigo}`,
                            );

                            if (response.status === 200) {
                              showInfo(
                                "Cliente liberado para cadastrar certificado.",
                              );
                              setCamposCertificadoDesabilitados(false);
                              carregarCertificados();
                            } else {
                              showError(
                                "Erro ao remover status de sem certificado.",
                              );
                            }
                          }
                        } catch {
                          showError("Erro ao alterar status de certificado.");
                        } finally {
                          setLoadingSwitch(false);
                        }
                      }}
                    />
                  </div>
                </div>

                {semCertificado && (
                  <div className="certificados-warning">
                    <strong>Cliente marcado como sem certificado.</strong>
                    <span>
                      Para cadastrar um certificado, desmarque a opção acima.
                    </span>
                  </div>
                )}

                <div className="certificados-upload-grid">
                  <div className="certificados-field certificados-field-nome">
                    <Label>Nome do certificado</Label>
                    <Input
                      name="nomeCertificado"
                      value={dadosCertificado.nomeCertificado}
                      onChange={(e) =>
                        setDadosCertificado((prev) => ({
                          ...prev,
                          nomeCertificado: e.target.value,
                        }))
                      }
                      placeholder="Ex: Certificado A1"
                      disabled={camposCertificadoDesabilitados}
                    />
                  </div>

                  <div className="certificados-field rel">
                    <Label>Senha do certificado</Label>
                    <Input
                      type={mostrarSenha ? "text" : "password"}
                      name="senha"
                      value={dadosCertificado.senha}
                      onChange={(e) =>
                        setDadosCertificado((prev) => ({
                          ...prev,
                          senha: e.target.value,
                        }))
                      }
                      placeholder="Senha do .pfx"
                      className="ssw-input input-with-icon"
                      disabled={camposCertificadoDesabilitados}
                    />
                    <button
                      type="button"
                      className="btn-eye"
                      aria-label={
                        mostrarSenha ? "Ocultar senha" : "Mostrar senha"
                      }
                      onClick={() => setMostrarSenha((prev) => !prev)}
                      disabled={camposCertificadoDesabilitados}
                    >
                      {mostrarSenha ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  </div>

                  <div className="certificados-field">
                    <Label>Arquivo PFX</Label>
                    <Input
                      type="file"
                      accept=".pfx"
                      disabled={!form.codigo || camposCertificadoDesabilitados}
                      onChange={(e) =>
                        setDadosCertificado((prev) => ({
                          ...prev,
                          arquivo: e.target.files?.[0] || null,
                        }))
                      }
                    />
                  </div>

                  <div className="certificados-upload-action">
                    <Button
                      variant="default"
                      onClick={salvarCertificado}
                      disabled={
                        !form.codigo ||
                        camposCertificadoDesabilitados ||
                        semCertificado
                      }
                    >
                      Salvar Certificado
                    </Button>
                  </div>
                </div>

                <div className="certificados-lista">
                  <div className="certificados-lista-header">
                    <div>
                      <h3>Certificados do Cliente</h3>
                      <p>
                        Certificados disponíveis para a licença selecionada.
                      </p>
                    </div>

                    <span className="certificados-counter">
                      {certificados.length}{" "}
                      {certificados.length === 1
                        ? "certificado"
                        : "certificados"}
                    </span>
                  </div>

                  {certificados.length > 0 ? (
                    <div className="certificados-table-wrap">
                      <table className="tabela-certificados">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Nome do Certificado</th>
                            <th>Validade</th>
                            <th>Data de Cadastro</th>
                            <th>Status NFS-e</th>
                            <th>Ações</th>
                          </tr>
                        </thead>

                        <tbody>
                          {certificados.map((cert) => {
                            const emissorNfse =
                              certificadoEhEmissorNfse(cert);
                            const podeTornarEmissor =
                              podeTornarCertificadoEmissorNfse(cert);
                            const certIncompleto =
                              cadastroAtualEhEmitenteNfse &&
                              !certificadoEhSemCertificado(cert) &&
                              !certificadoTemEstruturaEmissao(cert);
                            const vencido = certificadoEstaVencido(cert);
                            const loadingEmissor =
                              Number(definindoCertEmissorId) ===
                              Number(cert.ID);

                            return (
                              <tr
                                key={cert.ID}
                                className={
                                  emissorNfse ? "cert-emissor-row" : ""
                                }
                              >
                                <td className="cert-id-cell">
                                  <span
                                    className="cert-id"
                                    title={String(cert.ID || "")}
                                  >
                                    {cert.ID}
                                  </span>
                                </td>

                                <td>
                                  <div className="cert-name-cell">
                                    <strong>{cert.NomeCertificado}</strong>

                                    {emissorNfse && (
                                      <span className="nfse-cert-badge ativo">
                                        Emissor atual
                                      </span>
                                    )}

                                    {vencido && (
                                      <span className="nfse-cert-badge vencido">
                                        Vencido
                                      </span>
                                    )}
                                  </div>
                                </td>

                                <td className="cert-date-cell">
                                  {cert.Validade
                                    ? new Date(
                                        cert.Validade,
                                      ).toLocaleString("pt-BR")
                                    : "-"}
                                </td>

                                <td className="cert-date-cell">
                                  {cert.DtCadastro || cert.DataCadastro
                                    ? new Date(
                                        cert.DtCadastro ||
                                          cert.DataCadastro,
                                      ).toLocaleString("pt-BR")
                                    : "N/A"}
                                </td>

                                <td>
                                  {certificadoEhSemCertificado(cert) ? (
                                    <span className="nfse-cert-badge neutro">
                                      Sem certificado
                                    </span>
                                  ) : emissorNfse ? (
                                    <span className="nfse-cert-badge ativo">
                                      Vinculado à emissão
                                    </span>
                                  ) : certIncompleto ? (
                                    <span className="nfse-cert-badge alerta">
                                      Reenviar para NFS-e
                                    </span>
                                  ) : cadastroAtualEhEmitenteNfse ? (
                                    <span className="nfse-cert-badge disponivel">
                                      Disponível
                                    </span>
                                  ) : (
                                    <span className="nfse-cert-badge neutro">
                                      Cliente
                                    </span>
                                  )}
                                </td>

                                <td>
                                  <div className="cert-actions">
                                    {cert?.Centralizado ||
                                    cert?.Origem === "ANTONIO" ||
                                    cert?.PodeBaixar ? (
                                      <button
                                        type="button"
                                        className="btn-cert-download"
                                        onClick={() =>
                                          baixarCertificadoCentralizado(cert)
                                        }
                                      >
                                        Baixar
                                      </button>
                                    ) : cert.Caminho ? (
                                      <a
                                        className="btn-cert-download"
                                        href={cert.Caminho}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Baixar
                                      </a>
                                    ) : (
                                      <span className="cert-action-empty">-</span>
                                    )}

                                    {cadastroAtualEhEmitenteNfse &&
                                      !emissorNfse && (
                                        <button
                                          type="button"
                                          className="btn-cert-emissor"
                                          disabled={
                                            !podeTornarEmissor ||
                                            loadingEmissor
                                          }
                                          title={
                                            podeTornarEmissor
                                              ? "Definir como certificado emissor NFS-e"
                                              : "Certificado sem estrutura válida para emissão NFS-e"
                                          }
                                          onClick={() =>
                                            tornarCertificadoEmissorNfse(cert)
                                          }
                                        >
                                          {loadingEmissor
                                            ? "Vinculando..."
                                            : "Tornar emissor NFS-e"}
                                        </button>
                                      )}
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="empty-state compact certificados-empty">
                      <strong>Nenhum certificado cadastrado</strong>
                      <p>
                        Envie um certificado A1 para esta licença usando o
                        formulário acima.
                      </p>
                    </div>
                  )}
                </div>
              </section>
            </TabsContent>
          )}

          {/* ===== ABA: BOLETOS ===== */}
          {tabAtiva === "boletos" && canVerBoletos && (
            <TabsContent value="boletos">
              <section className="card section">
                <div className="section-title">Gestão de Boletos</div>

                <div className="div-bt-aplicar" style={{ marginBottom: 8 }}>
                  <Button
                    onClick={() => {
                      onChangeFiltro("page", 1);
                      fetchResumo();
                      fetchBoletos();
                    }}
                    disabled={!boletosHabilitados}
                  >
                    Aplicar Filtro
                  </Button>
                </div>

                <div
                  className="toolbar"
                  style={{ display: "flex", flexWrap: "wrap", gap: 8 }}
                >
                  <div className="field">
                    <Label>Vencimento de</Label>
                    <Input
                      type="date"
                      value={filtroBoleto.de}
                      onChange={(e) => onChangeFiltro("de", e.target.value)}
                    />
                  </div>
                  <div className="field">
                    <Label>até</Label>
                    <Input
                      type="date"
                      value={filtroBoleto.ate}
                      onChange={(e) => onChangeFiltro("ate", e.target.value)}
                    />
                  </div>
                  <div className="field" style={{ minWidth: 220 }}>
                    <Label>Busca (boleto/GUID)</Label>
                    <Input
                      value={filtroBoleto.search}
                      onChange={(e) => onChangeFiltro("search", e.target.value)}
                      placeholder="Texto livre"
                    />
                  </div>
                  <div className="field" style={{ width: 120 }}>
                    <Label>Valor mín.</Label>
                    <Input
                      value={filtroBoleto.minValor}
                      onChange={(e) =>
                        onChangeFiltro("minValor", e.target.value)
                      }
                      placeholder="0,00"
                    />
                  </div>
                  <div className="field" style={{ width: 120 }}>
                    <Label>Valor máx.</Label>
                    <Input
                      value={filtroBoleto.maxValor}
                      onChange={(e) =>
                        onChangeFiltro("maxValor", e.target.value)
                      }
                      placeholder="9999,99"
                    />
                  </div>

                  <div
                    className="field situacoes-field"
                    style={{ minWidth: 260 }}
                  >
                    <Label>Situações</Label>

                    <div className="chips">
                      {["Quitado", "Pendente", "Cancelado"].map((s) => {
                        const active = !!filtroBoleto.situacoes[s];
                        return (
                          <button
                            key={s}
                            type="button"
                            className={`chip ${
                              active ? "active" : ""
                            } chip--${s.toLowerCase()}`}
                            onClick={() => toggleSituacao(s)}
                            aria-pressed={active}
                            title={
                              active
                                ? `Filtrando por ${s}`
                                : `Incluir ${s} no filtro`
                            }
                          >
                            {s}
                          </button>
                        );
                      })}
                    </div>

                    <div className="chips-actions">
                      <button
                        type="button"
                        className="chip ghost"
                        onClick={() => setTodasSituacoes(true)}
                      >
                        Selecionar todos
                      </button>
                      <button
                        type="button"
                        className="chip ghost"
                        onClick={() => setTodasSituacoes(false)}
                      >
                        Limpar
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  className="resumo"
                  style={{ display: "flex", gap: 14, margin: "10px 0" }}
                >
                  <div className="kpi">
                    <b>Quitado:</b> {resumoBoletos.Quitado}
                  </div>
                  <div className="kpi">
                    <b>Pendente:</b> {resumoBoletos.Pendente}
                  </div>
                  <div className="kpi">
                    <b>Cancelado:</b> {resumoBoletos.Cancelado}
                  </div>
                  <div className="kpi">
                    <b>Total:</b> {resumoBoletos.total}
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: 8,
                    alignItems: "center",
                    margin: "8px 0",
                  }}
                >
                  <Label>Selecionados: {selectedGuids.size}</Label>
                  <select
                    value={novaSituacaoLote}
                    onChange={(e) => setNovaSituacaoLote(e.target.value)}
                    className="input native"
                    style={{ width: 200 }}
                  >
                    <option value="">Alterar situação...</option>
                    <option value="Quitado">Marcar como Quitado</option>
                    <option value="Pendente">Marcar como Pendente</option>
                    <option value="Cancelado">Marcar como Cancelado</option>
                  </select>
                  <Button
                    variant="default"
                    onClick={() => setConfirmLoteOpen(true)}
                    disabled={!novaSituacaoLote || selectedGuids.size === 0}
                  >
                    Aplicar em lote
                  </Button>
                </div>

                <div style={{ overflowX: "auto" }}>
                  <table className="table-sm" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th style={{ width: 34 }}>
                          <input
                            ref={headerChkRef}
                            type="checkbox"
                            onChange={(e) => setAllOnPage(e.target.checked)}
                            aria-label="Selecionar todos da página"
                          />
                        </th>
                        <th>Vencimento</th>
                        <th>Cliente</th>
                        <th>Boleto</th>
                        <th>GUID</th>
                        <th>Situação</th>
                        <th style={{ textAlign: "right" }}>Valor</th>
                        <th style={{ width: 220 }}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingBoletos ? (
                        <tr>
                          <td colSpan={8}>Carregando...</td>
                        </tr>
                      ) : boletos.length === 0 ? (
                        <tr>
                          <td colSpan={8}>Sem registros.</td>
                        </tr>
                      ) : (
                        boletos.map((b) => {
                          const isSelected = selectedGuids.has(b.GUID_BOLETO);
                          return (
                            <tr
                              key={b.GUID_BOLETO}
                              onClick={(e) => onRowClick(b.GUID_BOLETO, e)}
                              className={isSelected ? "row-selected" : ""}
                              style={{ cursor: "pointer" }}
                            >
                              <td onClick={(e) => e.stopPropagation()}>
                                <input
                                  type="checkbox"
                                  checked={isSelected}
                                  onChange={(e) =>
                                    setGuidChecked(
                                      b.GUID_BOLETO,
                                      e.target.checked,
                                    )
                                  }
                                  aria-label="Selecionar boleto"
                                />
                              </td>

                              <td>{b.DT_VENCIMENTO}</td>
                              <td>{b.NM_CLIENTE}</td>
                              <td title={b.NM_BOLETO}>
                                {b.NM_BOLETO?.slice(0, 40)}
                                {b.NM_BOLETO?.length > 40 ? "…" : ""}
                              </td>

                              <td onClick={(e) => e.stopPropagation()}>
                                <code style={{ fontSize: 12 }}>
                                  {b.GUID_BOLETO.slice(0, 8)}…
                                </code>{" "}
                                <Button
                                  size="sm"
                                  variant="ghost"
                                  onClick={async () => {
                                    await navigator.clipboard.writeText(
                                      b.GUID_BOLETO,
                                    );
                                    setCopiedGuid(b.GUID_BOLETO);
                                    showInfo("GUID copiado!");
                                    setTimeout(() => setCopiedGuid(null), 1500);
                                  }}
                                >
                                  {copiedGuid === b.GUID_BOLETO
                                    ? "Copiado!"
                                    : "Copiar"}
                                </Button>
                              </td>

                              <td>
                                <span className={badgeClass(b.DM_SITUACAO)}>
                                  {b.DM_SITUACAO}
                                </span>
                              </td>
                              <td style={{ textAlign: "right" }}>
                                {fmtBRL(b.VL_BOLETO)}
                              </td>

                              <td onClick={(e) => e.stopPropagation()}>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: 6,
                                    alignItems: "center",
                                  }}
                                >
                                  <select
                                    value={b.DM_SITUACAO}
                                    disabled={updatingGuid === b.GUID_BOLETO}
                                    onChange={(e) =>
                                      aplicarSituacaoSingle(
                                        b.GUID_BOLETO,
                                        e.target.value,
                                      )
                                    }
                                    className="input native"
                                  >
                                    <option>Quitado</option>
                                    <option>Pendente</option>
                                    <option>Cancelado</option>
                                  </select>
                                  {updatingGuid === b.GUID_BOLETO && (
                                    <span style={{ fontSize: 12 }}>
                                      Salvando…
                                    </span>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>

                <div
                  className="pager"
                  style={{
                    marginTop: 10,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <div>
                    <Label>Linhas/página</Label>{" "}
                    <select
                      value={filtroBoleto.limit}
                      onChange={(e) =>
                        onChangeFiltro("limit", Number(e.target.value))
                      }
                      className="input native"
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                  </div>
                  <div style={{ marginLeft: "auto" }}>
                    <Button
                      variant="secondary"
                      disabled={filtroBoleto.page <= 1}
                      onClick={() =>
                        onChangeFiltro(
                          "page",
                          Math.max(1, filtroBoleto.page - 1),
                        )
                      }
                    >
                      Anterior
                    </Button>
                    <span className="page-indicator">
                      Página {filtroBoleto.page} de{" "}
                      {Math.max(
                        1,
                        Math.ceil(totalBoletos / filtroBoleto.limit),
                      )}
                    </span>

                    <Button
                      variant="secondary"
                      disabled={filtroBoleto.page >= totalPages}
                      onClick={() =>
                        onChangeFiltro(
                          "page",
                          Math.min(totalPages, filtroBoleto.page + 1),
                        )
                      }
                    >
                      Próxima
                    </Button>
                  </div>
                </div>

                <ConfirmDialog
                  open={confirmLoteOpen}
                  onClose={() => setConfirmLoteOpen(false)}
                  onConfirm={aplicarSituacaoLote}
                  titulo="Confirmar atualização em lote"
                  mensagem={`Aplicar situação "${novaSituacaoLote}" em ${selectedGuids.size} boletos selecionados?`}
                />
              </section>
            </TabsContent>
          )}
          {/* ===== ABA: computadores ===== */}
          {tabAtiva === "computadores" && (
            <TabsContent value="computadores">
              <section className="card section computadores-section">
                <div className="computadores-header">
                  <div>
                    <div className="section-title">Computadores da Licença</div>
                    <p className="section-subtitle">
                      Gerencie parâmetros e liberação do ID_MAQUINA_CLIENTE por
                      equipamento.
                    </p>
                  </div>

                  <div className="computadores-actions">
                    <span className="computadores-counter">
                      {computadores.length} equipamento(s)
                    </span>

                    <Button
                      variant="secondary"
                      onClick={() => carregarComputadoresLicenca(form.codigo)}
                      disabled={!form.codigo || loadingComputadores}
                    >
                      {loadingComputadores ? "Atualizando..." : "Recarregar"}
                    </Button>
                  </div>
                </div>

                {!form.codigo ? (
                  <div className="empty-state compact">
                    <strong>Nenhum cliente carregado.</strong>
                    <p>Selecione um cliente para visualizar os computadores.</p>
                  </div>
                ) : loadingComputadores ? (
                  <div className="empty-state compact">
                    <strong>Carregando computadores...</strong>
                    <p>Aguarde enquanto a base operacional é consultada.</p>
                  </div>
                ) : computadores.length === 0 ? (
                  <div className="empty-state compact">
                    <strong>Nenhum computador encontrado.</strong>
                    <p>Não há computadores ativos vinculados a esta licença.</p>
                  </div>
                ) : (
                  <div className="computadores-table-wrap">
                    <table className="table-sm computadores-table">
                      <thead>
                        <tr>
                          <th>ID/Token</th>
                          <th>Nome do Computador</th>
                          <th>PDV</th>
                          <th>Status</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {computadores.map((pc) => {
                          const idPc = pc.ID_COMPUTADOR || pc.TOKEN_COMPUTADOR;
                          const ativo = pc.DM_ATIVO === "S";

                          return (
                            <tr key={idPc}>
                              <td className="col-token">
                                <code title={idPc}>{idPc}</code>
                              </td>
                              <td>
                                <div className="pc-name">
                                  {pc.NM_COMPUTADOR || "—"}
                                </div>
                                <small className="pc-meta">
                                  MAC: {pc.MAC_ADDRESS || "não informado"}
                                </small>
                              </td>
                              <td>{pc.NR_PDV ?? "—"}</td>
                              <td>
                                <span
                                  className={
                                    ativo ? "badge success" : "badge muted"
                                  }
                                >
                                  {ativo ? "Ativo" : "Inativo"}
                                </span>
                              </td>
                              <td className="col-actions">
                                <Button
                                  size="sm"
                                  variant="outline"
                                  onClick={() => abrirEditorParametrosPc(pc)}
                                >
                                  <FiEdit style={{ marginRight: 6 }} />
                                  Parâmetros
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </section>
            </TabsContent>
          )}

          {tabAtiva === "boletos" && !canVerBoletos && (
            <TabsContent value="boletos">
              <p style={{ marginTop: 12 }}>
                Acesso negado: apenas FINANCEIRO/ADM.
              </p>
            </TabsContent>
          )}
        </Tabs>
      </div>

      {/* Modais auxiliares */}
      {showModalEditarPlano && planoSelecionado && (
        <ConfirmDialog
          onClose={() => setShowModalEditarPlano(false)}
          title="Editar Plano"
        >
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              try {
                const valorCobrado = formatarValorMonetario(
                  planoSelecionado.ValorCobrado,
                );

                if (!valorCobrado || (parseValorMonetario(valorCobrado) ?? 0) <= 0) {
                  showError("Informe um valor cobrado válido.");
                  return;
                }

                await api.put(`/ClientesPlanos/plano/${planoSelecionado.ID}`, {
                  Plano: planoSelecionado.Plano,
                  ValorBase:
                    formatarValorMonetario(planoSelecionado.ValorBase || "0") ||
                    "0,00",
                  // Mantém vírgula para compatibilidade com o banco/sistema legado.
                  ValorCobrado: valorCobrado,
                });
                showInfo("Plano atualizado com sucesso.");
                setShowModalEditarPlano(false);
                atualizarDadosCliente();
              } catch {
                showError("Erro ao atualizar plano.");
              }
            }}
            className="form-edicao-planos"
          >
            <div className="form-field">
              <Label>Plano</Label>
              <Input
                value={planoSelecionado.Plano}
                onChange={(e) =>
                  setPlanoSelecionado({
                    ...planoSelecionado,
                    Plano: e.target.value,
                  })
                }
                required
              />
            </div>
            <div className="form-field">
              <Label>Valor Cobrado</Label>
              <Input
                type="text"
                value={planoSelecionado.ValorCobrado}
                onChange={(e) =>
                  setPlanoSelecionado({
                    ...planoSelecionado,
                    ValorCobrado: e.target.value,
                  })
                }
                required
              />
            </div>
            <div className="flex justify-end gap-2 mt-4">
              <Button
                type="button"
                variant="ghost"
                onClick={() => setShowModalEditarPlano(false)}
              >
                Cancelar
              </Button>
              <Button type="submit">Salvar</Button>
            </div>
          </form>
        </ConfirmDialog>
      )}

      {showModalPlanos && (
        <ModalAdicionarPlanos
          clienteId={form.codigo}
          onClose={() => setShowModalPlanos(false)}
          onSaveSuccess={() => buscarInformacoesCadastro(form.codigo)}
        />
      )}

      {showRestricaoModal && (
        <div
          className="cadastro-info-modal-backdrop"
          role="presentation"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) setShowRestricaoModal(false);
          }}
        >
          <section
            className="cadastro-info-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="cadastro-restricao-title"
          >
            <header className="cadastro-info-modal-header">
              <div className="cadastro-info-modal-title">
                <span className="cadastro-info-modal-icon" aria-hidden="true">
                  !
                </span>
                <div>
                  <h2 id="cadastro-restricao-title">Restrição do cliente</h2>
                  <p>Informação importante para consulta antes do atendimento.</p>
                </div>
              </div>

              <button
                type="button"
                className="cadastro-info-modal-close"
                onClick={() => setShowRestricaoModal(false)}
                aria-label="Fechar aviso"
                title="Fechar"
              >
                ×
              </button>
            </header>

            <div className="cadastro-info-modal-body">
              {(form?.restricoes || "").trim()}
            </div>

            <footer className="cadastro-info-modal-footer">
              <Button type="button" onClick={() => setShowRestricaoModal(false)}>
                Entendi
              </Button>
            </footer>
          </section>
        </div>
      )}

      {/* Modal de boletos para cancelamento */}
      {cancelBoletosModalOpen && (
        <ConfirmDialog
          open={cancelBoletosModalOpen}
          onClose={cancelarFluxoCancelamento}
          onConfirm={confirmarCancelamentoBoletos}
          titulo="Boletos pendentes do cliente"
          mensagem={
            <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
              {cancelBoletosLoading ? (
                <p>Carregando boletos...</p>
              ) : cancelBoletosLista.length === 0 ? (
                <p>
                  Cliente não possui boletos pendentes. Ao confirmar, serão
                  cancelados apenas agendamentos e chamados em aberto para este
                  cliente.
                </p>
              ) : (
                <>
                  <p style={{ marginBottom: 8 }}>
                    Selecione quais boletos serão <b>cancelados</b>. Os não
                    selecionados permanecerão como <b>Pendente</b>.
                  </p>
                  <p style={{ marginBottom: 8 }}>
                    Ao confirmar, agendamentos e chamados em aberto para este
                    cliente também serão cancelados.
                  </p>
                  <table className="table-sm" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th />
                        <th>Vencimento</th>
                        <th>Boleto</th>
                        <th>GUID</th>
                        <th style={{ textAlign: "right" }}>Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cancelBoletosLista.map((b) => {
                        const marcado = cancelBoletosSelecionados.has(
                          b.GUID_BOLETO,
                        );
                        return (
                          <tr key={b.GUID_BOLETO}>
                            <td>
                              <input
                                type="checkbox"
                                checked={marcado}
                                onChange={() =>
                                  toggleBoletoCancelSelecionado(b.GUID_BOLETO)
                                }
                              />
                            </td>
                            <td>{b.DT_VENCIMENTO}</td>
                            <td title={b.NM_BOLETO}>
                              {b.NM_BOLETO?.slice(0, 40)}
                              {b.NM_BOLETO?.length > 40 ? "…" : ""}
                            </td>
                            <td>
                              <code style={{ fontSize: 11 }}>
                                {b.GUID_BOLETO.slice(0, 8)}…
                              </code>
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {fmtBRL(b.VL_BOLETO)}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          }
        />
      )}

      <ConfirmDialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={confirmarExclusao}
        titulo="Excluir cadastro"
        mensagem={`Deseja realmente excluir o cliente "${form.razaoSocial}"?`}
      />

      {/* Modal de edição de empresa da licença */}
      {empresaModalOpen && (
        <ConfirmDialog
          open={empresaModalOpen}
          onClose={() => setEmpresaModalOpen(false)}
          onConfirm={handleSalvarEmpresa}
          titulo={`Empresa da licença ${empresaForm.nrLicenca || ""}`}
          mensagem={
            <div
              style={{
                maxHeight: "60vh",
                overflowY: "auto",
                display: "grid",
                gap: 12,
              }}
            >
              {/* Dados cadastrais da empresa */}
              <div className="grid grid-2">
                <div>
                  <Label>Razão Social</Label>
                  <Input
                    value={empresaForm.razaoSocial}
                    onChange={(e) =>
                      handleChangeEmpresaForm("razaoSocial", e.target.value)
                    }
                    placeholder="Razão Social"
                  />
                </div>
                <div>
                  <Label>Nome Fantasia</Label>
                  <Input
                    value={empresaForm.nomeFantasia}
                    onChange={(e) =>
                      handleChangeEmpresaForm("nomeFantasia", e.target.value)
                    }
                    placeholder="Nome Fantasia"
                  />
                </div>
              </div>

              <div className="grid grid-3">
                <div>
                  <Label>CNPJ</Label>
                  <Input
                    value={empresaForm.cnpj}
                    onChange={(e) =>
                      handleChangeEmpresaForm("cnpj", e.target.value)
                    }
                    placeholder="CPF ou CNPJ alfanumérico"
                    maxLength={18}
                  />
                </div>
                <div>
                  <Label>RG / IE</Label>
                  <Input
                    value={empresaForm.rgIe}
                    onChange={(e) =>
                      handleChangeEmpresaForm("rgIe", e.target.value)
                    }
                    placeholder="RG / Inscrição Estadual"
                  />
                </div>
                <div>
                  <Label>Telefone</Label>
                  <Input
                    value={empresaForm.telefone}
                    onChange={(e) =>
                      handleChangeEmpresaForm("telefone", e.target.value)
                    }
                    placeholder="(00) 00000-0000"
                  />
                </div>
              </div>

              <div className="grid grid-3">
                <div className="rel">
                  <Label>CEP</Label>
                  <Input
                    value={empresaForm.cep}
                    onChange={(e) =>
                      handleChangeEmpresaForm("cep", e.target.value)
                    }
                    placeholder="00000-000"
                  />
                </div>
                <div>
                  <Label>Cidade</Label>
                  <Input
                    value={empresaForm.cidade}
                    onChange={(e) =>
                      handleChangeEmpresaForm("cidade", e.target.value)
                    }
                    placeholder="Cidade"
                  />
                </div>
                <div>
                  <Label>UF</Label>
                  <Input
                    value={empresaForm.UF}
                    onChange={(e) =>
                      handleChangeEmpresaForm(
                        "UF",
                        e.target.value.toUpperCase(),
                      )
                    }
                    maxLength={2}
                    placeholder="UF"
                  />
                </div>
              </div>

              <div className="grid grid-4">
                <div className="col-span-2">
                  <Label>Rua</Label>
                  <Input
                    value={empresaForm.rua}
                    onChange={(e) =>
                      handleChangeEmpresaForm("rua", e.target.value)
                    }
                    placeholder="Rua"
                  />
                </div>
                <div>
                  <Label>Número</Label>
                  <Input
                    value={empresaForm.numero}
                    onChange={(e) =>
                      handleChangeEmpresaForm("numero", e.target.value)
                    }
                    placeholder="Número"
                  />
                </div>
                <div>
                  <Label>Bairro</Label>
                  <Input
                    value={empresaForm.bairro}
                    onChange={(e) =>
                      handleChangeEmpresaForm("bairro", e.target.value)
                    }
                    placeholder="Bairro"
                  />
                </div>
              </div>

              <div>
                <Label>Complemento</Label>
                <Input
                  value={empresaForm.complemento}
                  onChange={(e) =>
                    handleChangeEmpresaForm("complemento", e.target.value)
                  }
                  placeholder="Complemento"
                />
              </div>

              <div>
                <Label>E-mail</Label>
                <Input
                  value={empresaForm.email}
                  onChange={(e) =>
                    handleChangeEmpresaForm("email", e.target.value)
                  }
                  placeholder="email@empresa.com.br"
                />
              </div>

              {/* Bloco futuro: usuários da empresa */}
              <div
                style={{
                  marginTop: 12,
                  paddingTop: 12,
                  borderTop: "1px solid #eee",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 8,
                  }}
                >
                  <div className="section-subtitle">
                    Usuários vinculados a esta empresa
                  </div>
                  <Button
                    size="sm"
                    variant="secondary"
                    type="button"
                    onClick={() =>
                      showInfo(
                        "Funcionalidade de usuários por empresa será implementada posteriormente.",
                      )
                    }
                  >
                    Incluir usuário
                  </Button>
                </div>

                {usuariosEmpresa.length === 0 ? (
                  <p style={{ fontSize: 13 }}>
                    Nenhum usuário vinculado a esta empresa. (Backlog)
                  </p>
                ) : (
                  <table className="table-sm" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Nome</th>
                        <th>Login</th>
                        <th>Perfil</th>
                      </tr>
                    </thead>
                    <tbody>
                      {usuariosEmpresa.map((u) => (
                        <tr key={u.id}>
                          <td>{u.id}</td>
                          <td>{u.nome}</td>
                          <td>{u.login}</td>
                          <td>{u.perfil}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>

              {/* Botão extra para deleção – só aparece em modo edição */}
              {empresaForm.id && (
                <div
                  style={{
                    marginTop: 16,
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    type="button"
                    variant="destructive"
                    onClick={handleExcluirEmpresa}
                    disabled={loadingEmpresa}
                  >
                    Excluir empresa
                  </Button>
                </div>
              )}
            </div>
          }
        />
      )}

      {/* ===== Modal Parametros do Computador ===== */}
      <ConfirmDialog
        open={paramModalOpen}
        onClose={() => {
          if (paramSaving || maquinaClienteInfo.deleting) return;
          setParamModalOpen(false);
          setParamEdit({});
          setParamList([]);
          setParamGovernancaCatalogo([]);
          setParamGovernancaJustificativa("");
          setParamGovernancaConfirmacao("");
          setParamGovernancaResultado(null);
          resetMaquinaClienteInfo();
        }}
        onConfirm={salvarParametrosAlterados}
        titulo={`Parâmetros do Computador (${getPcId(pcSelecionado)})`}
        // ✅ AQUI
        panelClassName="param-modal-panel"
        mensagem={
          <div className="param-modal">
            <div className="machine-client-card">
              <div className="machine-client-head">
                <div>
                  <div className="machine-client-eyebrow">
                    Segurança da máquina
                  </div>
                  <h4>ID_MAQUINA_CLIENTE</h4>
                  <p>
                    Campo usado para validar o vínculo físico entre a licença, o
                    computador cadastrado e a máquina do cliente.
                  </p>
                </div>

                <span
                  className={
                    maquinaClienteInfo.idMaquinaCliente
                      ? "machine-status linked"
                      : "machine-status free"
                  }
                >
                  {maquinaClienteInfo.loading
                    ? "Consultando"
                    : maquinaClienteInfo.idMaquinaCliente
                      ? "Vinculado"
                      : "Sem vínculo"}
                </span>
              </div>

              <div className="machine-client-grid">
                <div className="machine-client-field">
                  <Label>ID da máquina cliente</Label>
                  <Input
                    value={
                      maquinaClienteInfo.loading
                        ? "Carregando..."
                        : maquinaClienteInfo.idMaquinaCliente || ""
                    }
                    readOnly
                    placeholder="Nenhum ID_MAQUINA_CLIENTE vinculado."
                    title={maquinaClienteInfo.idMaquinaCliente || ""}
                  />
                  {maquinaClienteInfo.erro ? (
                    <small className="machine-client-error">
                      {maquinaClienteInfo.erro}
                    </small>
                  ) : (
                    <small className="machine-client-help">
                      Ao remover, apenas a coluna ID_MAQUINA_CLIENTE será limpa.
                    </small>
                  )}
                </div>

                <div className="machine-client-actions">
                  <Button
                    type="button"
                    variant="destructive"
                    onClick={deletarIdMaquinaCliente}
                    disabled={
                      maquinaClienteInfo.loading ||
                      maquinaClienteInfo.deleting ||
                      !maquinaClienteInfo.idMaquinaCliente
                    }
                    title={
                      maquinaClienteInfo.idMaquinaCliente
                        ? "Remover ID_MAQUINA_CLIENTE"
                        : "Nenhum ID_MAQUINA_CLIENTE vinculado"
                    }
                  >
                    <FiTrash style={{ marginRight: 6 }} />
                    {maquinaClienteInfo.deleting
                      ? "Removendo..."
                      : "Deletar ID_MAQUINA_CLIENTE"}
                  </Button>
                </div>
              </div>

              <div className="machine-client-meta">
                <span>Licença: {form.codigo || "—"}</span>
                <span>Computador: {getPcId(pcSelecionado) || "—"}</span>
                <span>Nome: {pcSelecionado?.NM_COMPUTADOR || "—"}</span>
              </div>
            </div>

            {/* Toolbar opcional (melhora usabilidade) */}
            <div className="param-toolbar">
              <div className="param-kpis">
                <span className="pill">
                  Total: <b>{paramList.length}</b>
                </span>
                <span className="pill">
                  Exibindo: <b>{paramView.length}</b>
                </span>
                <span className="pill">
                  Alterados: <b>{paramAlteracoes.length}</b>
                </span>
                <span className="pill governanca">
                  Governados alterados: <b>{paramGovernadosAlterados.length}</b>
                </span>
                <span className="pill param-user-level">
                  Meu nível: <b>N{nivelParametroUsuario}</b>
                </span>
                <span className="pill param-admin-direct">
                  Legado direto: <b>N4+</b>
                </span>
                {paramGovernancaLoading && (
                  <span className="pill muted">Catálogo governança...</span>
                )}
              </div>

              <div
                className="param-filters"
                style={{ display: "flex", gap: 8, flexWrap: "wrap" }}
              >
                <select
                  className="input native"
                  value={paramSearchMode}
                  onChange={(e) => setParamSearchMode(e.target.value)}
                  style={{ width: 160 }}
                >
                  <option value="all">Tudo</option>
                  <option value="grupo">Somente Grupo</option>
                  <option value="param">Somente Parâmetro</option>
                </select>

                <Input
                  value={paramSearch}
                  onChange={(e) => setParamSearch(e.target.value)}
                  placeholder="Buscar por grupo ou número do parâmetro..."
                  style={{ minWidth: 320 }}
                />

                <Button
                  type="button"
                  variant="secondary"
                  onClick={() => setParamSearch("")}
                  disabled={!paramSearch}
                >
                  Limpar
                </Button>
              </div>
            </div>

            <div className="param-permission-strip">
              <div>
                <strong>Permissão de alteração</strong>
                <span>
                  Parâmetros governados são liberados quando seu Nível de Parâmetros
                  é maior ou igual ao NIVEL_MUTACAO. Parâmetros legados/não governados
                  podem ter o VL_PARAMETRO alterado a partir do N4.
                </span>
              </div>
              <span className="param-permission-level">N{nivelParametroUsuario}</span>
            </div>

            {temParametrosGovernadosAlterados && (
              <div className="param-governanca-box">
                <div className="param-governanca-head">
                  <div>
                    <strong>Alteração governada</strong>
                    <p>
                      Esta alteração passa pela governança, grava auditoria,
                      materializa na tabela legado e atualiza/cria sync pendente.
                    </p>
                  </div>
                  <span className="param-governanca-count">
                    {paramGovernadosAlterados.length} parâmetro(s)
                  </span>
                </div>

                <div className="param-governanca-grid">
                  <div className="param-governanca-field">
                    <Label>Justificativa operacional</Label>
                    <textarea
                      className="ssw-textarea param-governanca-textarea"
                      value={paramGovernancaJustificativa}
                      onChange={(e) =>
                        setParamGovernancaJustificativa(e.target.value)
                      }
                      placeholder="Informe o motivo da alteração deste parâmetro."
                    />
                  </div>

                  <div className="param-governanca-field">
                    <Label>Confirmação textual</Label>
                    <Input
                      value={paramGovernancaConfirmacao}
                      onChange={(e) =>
                        setParamGovernancaConfirmacao(e.target.value)
                      }
                      placeholder={
                        fraseConfirmacaoGovernanca ||
                        "Sem confirmação textual obrigatória."
                      }
                      disabled={!fraseConfirmacaoGovernanca}
                    />
                    {fraseConfirmacaoGovernanca ? (
                      <small>
                        Digite exatamente: <b>{fraseConfirmacaoGovernanca}</b>
                      </small>
                    ) : (
                      <small>
                        Este parâmetro governado não exige frase textual.
                      </small>
                    )}
                  </div>
                </div>

                {frasesConfirmacaoGovernanca.length > 1 && (
                  <div className="param-governanca-alert">
                    Existem frases de confirmação diferentes. Salve um parâmetro
                    governado por vez.
                  </div>
                )}
              </div>
            )}

            {paramGovernancaResultado && (
              <div className="param-governanca-result">
                Governança aplicada: {paramGovernancaResultado.governados || 0}
                . Legado direto: {paramGovernancaResultado.legados || 0}.
              </div>
            )}

            <div className="param-body">
              {paramLoading ? (
                <p>Carregando parâmetros...</p>
              ) : paramList.length === 0 ? (
                <p>Nenhum parâmetro encontrado para este computador.</p>
              ) : (
                <div className="param-table-wrap">
                  <table className="param-table">
                    <thead>
                      <tr>
                        <th
                          className="col-grupo"
                          style={{ cursor: "pointer" }}
                          onClick={() => toggleSort("GRUPO_PARAMETRO")}
                        >
                          Grupo {sortIcon("GRUPO_PARAMETRO")}
                        </th>

                        <th
                          className="col-param"
                          style={{ cursor: "pointer" }}
                          onClick={() => toggleSort("NM_PARAMETRO")}
                        >
                          Parâmetro {sortIcon("NM_PARAMETRO")}
                        </th>

                        <th className="col-controle">Controle</th>

                        <th
                          className="col-valor"
                          style={{ cursor: "pointer" }}
                          onClick={() => toggleSort("VL_PARAMETRO")}
                        >
                          Valor {sortIcon("VL_PARAMETRO")}
                        </th>

                        <th
                          className="col-desc"
                          style={{ cursor: "pointer" }}
                          onClick={() => toggleSort("DS_PARAMETRO")}
                        >
                          Descrição {sortIcon("DS_PARAMETRO")}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {paramView.map((p) => {
                        const catalogoGovernanca = encontrarCatalogoGovernanca(p);
                        const governado = Boolean(catalogoGovernanca);
                        const nivelGovernanca = governado
                          ? getNivelMutacaoCatalogo(catalogoGovernanca)
                          : null;
                        const codigoTecnico = governado
                          ? getCodigoTecnicoCatalogo(catalogoGovernanca)
                          : "";
                        const podeEditar = podeAlterarParametro(
                          p,
                          catalogoGovernanca,
                        );
                        const motivoBloqueio = governado
                          ? `Exige N${nivelGovernanca}; seu nível é N${nivelParametroUsuario}`
                          : `Parâmetro legado: exige N4; seu nível é N${nivelParametroUsuario}`;

                        return (
                          <tr
                            key={chaveParam(p)}
                            className={[
                              governado ? "param-row-governado" : "param-row-legado",
                              !podeEditar ? "param-row-bloqueado" : "",
                            ]
                              .filter(Boolean)
                              .join(" ")}
                          >
                            <td className="col-grupo">
                              <span className="badge">
                                {p.GRUPO_PARAMETRO || "—"}
                              </span>
                            </td>

                            <td className="col-param">
                              <code>{p.NM_PARAMETRO}</code>
                            </td>

                            <td className="col-controle">
                              {governado ? (
                                <span
                                  className={`param-governanca-badge nivel-${nivelGovernanca}`}
                                  title={codigoTecnico}
                                >
                                  Governado · N{nivelGovernanca}
                                  {podeEditar ? " · liberado" : " · bloqueado"}
                                </span>
                              ) : (
                                <span
                                  className={`param-legado-badge ${
                                    podeEditar ? "liberado" : "bloqueado"
                                  }`}
                                >
                                  Legado · {podeEditar ? "N4+" : "exige N4"}
                                </span>
                              )}
                            </td>

                            <td className="col-valor">
                              <Input
                                value={getVlAtual(p)}
                                onChange={(e) =>
                                  onChangeVlParametro(p, e.target.value)
                                }
                                placeholder="VL_PARAMETRO"
                                disabled={!podeEditar || paramSaving}
                                className={[
                                  governado ? "input-governado" : "",
                                  !podeEditar ? "input-param-bloqueado" : "",
                                ]
                                  .filter(Boolean)
                                  .join(" ")}
                                title={
                                  podeEditar
                                    ? governado
                                      ? `Alteração governada: ${codigoTecnico} · exige N${nivelGovernanca}`
                                      : "Alteração direta do VL_PARAMETRO liberada para N4/N5"
                                    : motivoBloqueio
                                }
                              />
                            </td>

                            <td className="col-desc">{p.DS_PARAMETRO || "—"}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  <div className="param-hint">
                    * Governados respeitam o NIVEL_MUTACAO e passam por auditoria/materialização/sync. Legados permitem alteração do VL_PARAMETRO a partir do N4; campos técnicos continuam restritos a ADM.
                    {paramSaving && <span className="saving"> Salvando…</span>}
                  </div>
                </div>
              )}
            </div>
          </div>
        }
      />
    </MainLayout>
  );
};

export default CadastroTela;
